// Exact English fallback sources absent from the canonical runtime key.
// Review scope only; no translations or approvals are supplied.
export const PATIENT_RUNTIME_FALLBACK_SOURCES = [
  {
    "id": "hospitalJourney:journeys.generic-cancer-care.stages.assessment-treatment.description",
    "sourceText": "Tests may be used to confirm a diagnosis, understand the cancer in more detail and plan treatment. Your team should explain the purpose, benefits, risks and alternatives of any treatment offered.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.cancer-care.stages.assessment-treatment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-cancer-care.stages.support-follow-up.description",
    "sourceText": "Support may include symptom control, psychological support, nutrition, rehabilitation, financial or practical advice and help for families or carers, alongside treatment and follow-up.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.cancer-care.stages.support-follow-up"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-cancer-care.stages.understanding-team.description",
    "sourceText": "Cancer care is usually delivered by a multidisciplinary team. Knowing your main point of contact can make it easier to understand appointments, tests and treatment plans.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.cancer-care.stages.understanding-team"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-cardiology.stages.assessment.description",
    "sourceText": "Your team may use your symptoms, examination, blood tests, ECGs, heart monitoring, scans or other investigations to understand what is happening and what needs to happen next.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.cardiology.stages.assessment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-cardiology.stages.follow-up.description",
    "sourceText": "Follow-up can include medication review, repeat testing and cardiac rehabilitation. Make sure you know who to contact if symptoms change before your next appointment.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.cardiology.stages.follow-up"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-cardiology.stages.treatment.description",
    "sourceText": "Treatment may include medicines, monitoring, lifestyle support or procedures. Ask what each treatment is intended to achieve and what side effects or warning symptoms to look out for.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.cardiology.stages.treatment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-chemotherapy.stages.planning.description",
    "sourceText": "Before treatment starts, the team will explain the treatment aim, schedule, blood tests, consent, likely side effects and any medicines you need at home.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.chemotherapy.stages.planning"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-chemotherapy.stages.support.description",
    "sourceText": "Side effects can occur between treatments. Keep the treatment team’s urgent contact details and follow their advice about fever, infection, uncontrolled symptoms or other concerns.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.chemotherapy.stages.support"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-chemotherapy.stages.treatment.description",
    "sourceText": "Treatment may be given by drip, injection or tablets depending on the regimen. Nurses and pharmacists will complete safety checks and explain what to expect during the visit.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.chemotherapy.stages.treatment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-critical-care-visitor.stages.arriving.description",
    "sourceText": "Critical care can feel unfamiliar because of monitors, alarms, tubes and equipment. Staff can explain what you are seeing and any visiting arrangements for the unit.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.critical-care-visitor.stages.arriving"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-critical-care-visitor.stages.next.description",
    "sourceText": "As the patient’s condition changes, the team may discuss reducing organ support, rehabilitation, transfer to a ward or longer-term critical care needs.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.critical-care-visitor.stages.next"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-critical-care-visitor.stages.updates.description",
    "sourceText": "Ask the team how and when clinical updates are usually given, who the main family contact should be and what support is available for relatives and carers.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.critical-care-visitor.stages.updates"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-ct.stages.after.description",
    "sourceText": "If contrast is used, you may be asked to wait briefly or drink extra fluid. Ask when the scan will be reported and who will discuss the result with you.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.ct.stages.after"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-ct.stages.before.description",
    "sourceText": "Follow any instructions about eating, drinking or medicines. Tell the team about pregnancy, allergies, kidney problems or previous reactions if contrast dye may be used.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.ct.stages.before"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-ct.stages.during.description",
    "sourceText": "The radiographer will position you on the scanner and explain when to keep still or hold your breath. Contrast may be given by injection or as a drink for some examinations.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.ct.stages.during"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-day-surgery.stages.before.description",
    "sourceText": "Check where and when to attend, what to bring, and whether you have been asked to stop eating, drinking or taking any medicines before your procedure.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.day-surgery.stages.before"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-day-surgery.stages.home.description",
    "sourceText": "Before leaving, make sure you understand your medicines, wound or dressing care, activity advice, follow-up plan and who to contact if you are worried.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.day-surgery.stages.home"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-day-surgery.stages.procedure-recovery.description",
    "sourceText": "After admission you will meet members of the surgical, anaesthetic and nursing teams. Following the procedure, staff will monitor your recovery and help with pain relief, food and drink, and getting up safely.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.day-surgery.stages.procedure-recovery"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-discharge-recovery.stages.first-days-home.description",
    "sourceText": "It is common to need time to regain confidence and energy after a hospital stay. Follow the advice you have been given and ask for help if managing at home is harder than expected.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.discharge-recovery.stages.first-days-home"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-discharge-recovery.stages.follow-up.description",
    "sourceText": "Know what follow-up is planned, how you will receive results or appointments, and which symptoms should prompt you to contact your team, GP, NHS 111 or emergency services.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.discharge-recovery.stages.follow-up"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-discharge-recovery.stages.getting-ready.description",
    "sourceText": "Before leaving hospital, check that you understand your medicines, mobility and equipment needs, wound or self-care advice, transport and any support being arranged.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.discharge-recovery.stages.getting-ready"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-emergency-department.stages.arrival.description",
    "sourceText": "A member of the emergency team will assess how urgently you need care. Depending on your symptoms, observations, pain relief, tests or treatment may begin early.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.emergency-department.stages.arrival"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-emergency-department.stages.assessment-treatment.description",
    "sourceText": "You may see several professionals while the team gathers information, reviews test results and decides what treatment or specialist input is needed.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.emergency-department.stages.assessment-treatment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-emergency-department.stages.next.description",
    "sourceText": "Once the team has enough information, they will explain whether you can go home, need further observation, should be admitted, or need review by another service.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.emergency-department.stages.next"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-endoscopy.stages.preparing.description",
    "sourceText": "Preparation varies by procedure and may include fasting, bowel preparation or changing medicines. Follow the instructions carefully and contact the unit if anything is unclear.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.endoscopy.stages.preparing"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-endoscopy.stages.procedure.description",
    "sourceText": "Before the procedure, staff will confirm consent and discuss comfort options such as throat spray, pain relief or sedation. Monitoring is used where needed.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.endoscopy.stages.procedure"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-endoscopy.stages.recovery.description",
    "sourceText": "Afterwards, you may need time to recover from sedation and may need someone to take you home. Ask about immediate findings, biopsies, results and symptoms that need urgent advice.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.endoscopy.stages.recovery"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-imaging-diagnostics.stages.before.description",
    "sourceText": "Follow the preparation instructions for your specific test, including advice about food, drink, medicines, clothing, implants or pregnancy where relevant.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.imaging-diagnostics.stages.before"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-imaging-diagnostics.stages.results.description",
    "sourceText": "The person performing the test may not be able to give you a result immediately. Ask when the report is expected, who will explain it and what happens next.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.imaging-diagnostics.stages.results"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-imaging-diagnostics.stages.visit.description",
    "sourceText": "A member of the diagnostic team will confirm your details, explain the test and answer questions. Some tests use contrast, sedation or additional monitoring.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.imaging-diagnostics.stages.visit"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-inpatient-admission.stages.before-admission.description",
    "sourceText": "Check when and where to attend, what to bring and whether you have been given instructions about medicines, food or drink before admission.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.inpatient-admission.stages.before-admission"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-inpatient-admission.stages.during-stay.description",
    "sourceText": "Your ward team will review your condition, medicines and treatment plan. You may also meet therapists, pharmacists or specialist teams depending on what support you need.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.inpatient-admission.stages.during-stay"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-inpatient-admission.stages.leaving-hospital.description",
    "sourceText": "Before discharge, make sure you know about medicines, equipment, transport, community support, follow-up and who to contact if you have concerns.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.inpatient-admission.stages.leaving-hospital"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-inpatient-ward.stages.leaving.description",
    "sourceText": "Discharge planning should start before the day you leave. Make sure you understand your medicines, support needs, follow-up and what to do if you become unwell again.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.inpatient-ward.stages.leaving"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-inpatient-ward.stages.settling-in.description",
    "sourceText": "When you arrive on the ward, staff will confirm your details, medicines, immediate needs and plan of care. Ask who your main medical and nursing teams are.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.inpatient-ward.stages.settling-in"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-inpatient-ward.stages.ward-care.description",
    "sourceText": "During your stay you may have regular reviews, medicines, tests, therapy or specialist input. The plan can change as your condition improves or new information becomes available.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.inpatient-ward.stages.ward-care"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-maternity.stages.after-birth.description",
    "sourceText": "After birth, staff will support recovery, feeding, newborn checks and planning for home, including who will provide follow-up in the community.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.maternity.stages.after-birth"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-maternity.stages.labour-birth.description",
    "sourceText": "During labour and birth, the team supporting you may change depending on your preferences, your progress and whether you or your baby need additional monitoring or treatment.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.maternity.stages.labour-birth"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-maternity.stages.pregnancy.description",
    "sourceText": "During pregnancy you may meet different maternity professionals for routine checks, scans, screening, advice and any additional specialist care you need.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.maternity.stages.pregnancy"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-maternity.stages.preparing-birth.description",
    "sourceText": "As birth approaches, your team can help you understand your options, where to attend, what to bring and what to do if labour starts or you have concerns.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.maternity.stages.preparing-birth"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-mental-health.stages.assessment.description",
    "sourceText": "An assessment should give you space to describe what has been happening, what matters to you, your physical health, medicines, support network and any immediate safety concerns.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.mental-health.stages.assessment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-mental-health.stages.next-steps.description",
    "sourceText": "Make sure you know your main contact, what follow-up is planned and how to access urgent help if your mental health worsens between appointments.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.mental-health.stages.next-steps"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-mental-health.stages.support.description",
    "sourceText": "Care may include talking therapies, medicines, practical support, occupational therapy or social care. You should be involved in decisions and have the opportunity to ask about benefits, risks and alternatives.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.mental-health.stages.support"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-mri.stages.after.description",
    "sourceText": "Most people can leave soon after an MRI unless they have had sedation or other treatment. Ask who will review the scan and when you should expect the result.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.mri.stages.after"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-mri.stages.before.description",
    "sourceText": "MRI uses a strong magnetic field, so the team needs to know about implants, devices, metal fragments and pregnancy. Follow any instructions about food, drink, medicines or clothing.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.mri.stages.before"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-mri.stages.during.description",
    "sourceText": "The radiographer will position you safely, explain how to communicate during the scan and tell you when you need to keep still. Some scans use contrast dye.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.mri.stages.during"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-neurology-neurosurgery.stages.assessment.description",
    "sourceText": "Neurological assessment may involve a detailed history and examination alongside scans, nerve or muscle tests, blood tests or other specialist investigations.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.neurology-neurosurgery.stages.assessment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-neurology-neurosurgery.stages.recovery.description",
    "sourceText": "Some conditions need rehabilitation, symptom management or long-term follow-up. Physiotherapy, occupational therapy, specialist nursing and other services may be involved.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.neurology-neurosurgery.stages.recovery"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-neurology-neurosurgery.stages.specialist-care.description",
    "sourceText": "Depending on the diagnosis, care may involve medicines, monitoring, procedures or neurosurgery. Ask which team is coordinating your care and what the planned next step is.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.neurology-neurosurgery.stages.specialist-care"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-orthopaedics.stages.assessment.description",
    "sourceText": "Assessment may include examination, X-rays or other scans and discussion of how symptoms affect your movement, independence, work or daily activities.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.orthopaedics.stages.assessment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-orthopaedics.stages.rehabilitation.description",
    "sourceText": "Recovery often depends on gradually rebuilding movement and strength. Make sure you understand weight-bearing, exercises, equipment, wound care and follow-up.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.orthopaedics.stages.rehabilitation"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-orthopaedics.stages.treatment.description",
    "sourceText": "Treatment can range from advice, physiotherapy, medicines or injections to surgery. Ask what improvement is realistic and what preparation may make recovery easier.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.orthopaedics.stages.treatment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-outpatients.stages.after.description",
    "sourceText": "Before you leave, make sure you know what happens next, including tests, results, medicines, referrals, follow-up and who to contact if your symptoms change.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.outpatients.stages.after"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-outpatients.stages.before.description",
    "sourceText": "Check the appointment location, what to bring and whether you need any tests beforehand. It can help to write down the questions or concerns you most want to discuss.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.outpatients.stages.before"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-outpatients.stages.clinic.description",
    "sourceText": "Your appointment may involve assessment by one or more members of the team, examination, tests or discussion of treatment options. Ask if anything is unclear.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.outpatients.stages.clinic"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-paediatrics.stages.during-visit.description",
    "sourceText": "Staff should explain care in a way the child or young person can understand and involve parents or carers appropriately. Different specialists may join the team depending on the reason for the visit.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.paediatrics.stages.during-visit"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-paediatrics.stages.going-home.description",
    "sourceText": "Before leaving, check medicines, feeding or activity advice, follow-up, school or nursery considerations and who to contact if you are worried.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.paediatrics.stages.going-home"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-paediatrics.stages.preparing.description",
    "sourceText": "Age-appropriate preparation can help children and young people know what to expect. Bring medicines, relevant information and comfort items, and ask about fasting or other instructions if a procedure is planned.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.paediatrics.stages.preparing"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-radiotherapy.stages.after.description",
    "sourceText": "Some effects continue for a while after treatment finishes. Make sure you know what is expected, what symptoms to report and what follow-up has been arranged.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.radiotherapy.stages.after"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-radiotherapy.stages.planning.description",
    "sourceText": "Radiotherapy is carefully planned for the area being treated. Planning may involve a CT scan, positioning equipment, skin marks or moulds and instructions specific to your treatment.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.radiotherapy.stages.planning"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-radiotherapy.stages.treatment.description",
    "sourceText": "Therapeutic radiographers deliver treatment and check positioning at each visit. The treatment itself is usually painless, although side effects can build up over a course of treatment.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.radiotherapy.stages.treatment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-renal.stages.assessment.description",
    "sourceText": "Kidney care commonly involves blood and urine tests, blood-pressure monitoring, scans and review of medicines to understand kidney function and what may be affecting it.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.renal.stages.assessment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-renal.stages.ongoing-care.description",
    "sourceText": "Longer-term kidney care may involve regular blood tests, medication review, dietary support and planning ahead if kidney function changes.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.renal.stages.ongoing-care"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-renal.stages.treatment.description",
    "sourceText": "Treatment depends on the cause and severity of kidney problems and may include medicines, fluid or dietary changes, procedures or dialysis. Ask what is relevant to you and why.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.renal.stages.treatment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-respiratory.stages.assessment.description",
    "sourceText": "Assessment may include oxygen measurements, breathing tests, blood tests, chest imaging and discussion of symptoms, smoking, work or environmental exposures and previous lung conditions.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.respiratory.stages.assessment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-respiratory.stages.follow-up.description",
    "sourceText": "Follow-up may include repeat testing, specialist review or pulmonary rehabilitation. Know what worsening symptoms should prompt you to seek advice.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.respiratory.stages.follow-up"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-respiratory.stages.treatment.description",
    "sourceText": "Treatment may involve inhalers, tablets, oxygen, antibiotics, procedures or other therapies. Ask someone to check inhaler technique if you use inhaled medicines.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.respiratory.stages.treatment"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-stroke.stages.early-care.description",
    "sourceText": "Early stroke care focuses on confirming the diagnosis, identifying the type of stroke, monitoring for complications and starting appropriate treatment as quickly as possible.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.stroke.stages.early-care"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-stroke.stages.next-steps.description",
    "sourceText": "Planning may include medicines, equipment, help at home, community rehabilitation, driving advice and follow-up. Families and carers may also need information and support.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.stroke.stages.next-steps"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-stroke.stages.recovery.description",
    "sourceText": "Rehabilitation can begin early and may involve physiotherapy, occupational therapy, speech and language therapy, nursing and medical teams working towards goals that matter to you.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.stroke.stages.recovery"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-surgery-operation.stages.operation-day.description",
    "sourceText": "On the day, you may meet surgical, anaesthetic, theatre and recovery staff. They will confirm the procedure, discuss consent and anaesthesia, and complete safety checks before surgery.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.surgery-operation.stages.operation-day"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-surgery-operation.stages.preparing.description",
    "sourceText": "Before surgery, follow the instructions you have been given about fasting, medicines and arrival. Pre-operative assessment helps the team identify anything that needs planning in advance.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.surgery-operation.stages.preparing"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-surgery-operation.stages.recovery.description",
    "sourceText": "After surgery, the team will monitor pain, sickness, eating and drinking, mobility and any wounds or drains. Discharge depends on the operation and how your recovery is progressing.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.surgery-operation.stages.recovery"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-ultrasound.stages.after.description",
    "sourceText": "There is usually no recovery time after a standard ultrasound. Ask whether anything can be explained on the day and when the formal result will be available.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.ultrasound.stages.after"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-ultrasound.stages.before.description",
    "sourceText": "Preparation depends on the type of ultrasound. You may be asked to fast, drink water or arrive with a full bladder, so follow the instructions in your appointment information.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.ultrasound.stages.before"
    ]
  },
  {
    "id": "hospitalJourney:journeys.generic-ultrasound.stages.during.description",
    "sourceText": "The sonographer or other specialist will explain the examination and use gel and an ultrasound probe to obtain images. Some examinations are internal and should be explained beforehand.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:englishQuality.ultrasound.stages.during"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-cancer-care.stages.appointments-and-treatment.description",
    "sourceText": "Prepare for appointments and treatment, and understand what the team is aiming to achieve and monitor.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-cancer-care.stages.appointments-and-treatment.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-cancer-care.stages.support-and-urgent-concerns.description",
    "sourceText": "Find practical and emotional support and know who to contact if you become unwell or worried.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-cancer-care.stages.support-and-urgent-concerns.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-cancer-care.stages.support-and-urgent-concerns.title",
    "sourceText": "Support and urgent concerns",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-cancer-care.stages.support-and-urgent-concerns.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-cancer-care.stages.understanding-your-team.description",
    "sourceText": "Know your main point of contact and which professionals may be involved in your care.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-cancer-care.stages.understanding-your-team.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-childrens-services.stages.after-you-go-home.description",
    "sourceText": "Know who the family should contact if there are questions or concerns afterwards.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-childrens-services.stages.after-you-go-home.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-childrens-services.stages.after-you-go-home.title",
    "sourceText": "After you go home",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-childrens-services.stages.after-you-go-home.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-childrens-services.stages.before-you-come.description",
    "sourceText": "Prepare for the visit, find where to go and plan any extra support or adjustments.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-childrens-services.stages.before-you-come.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-childrens-services.stages.before-you-come.title",
    "sourceText": "Before you come",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-childrens-services.stages.before-you-come.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-childrens-services.stages.during-the-visit.description",
    "sourceText": "Understand what will happen, who can explain things and what may help a child or young person feel more comfortable.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-childrens-services.stages.during-the-visit.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-childrens-services.stages.during-the-visit.title",
    "sourceText": "During the visit",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-childrens-services.stages.during-the-visit.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-critical-care-visitor.stages.arriving-and-getting-oriented.description",
    "sourceText": "Understand the critical care environment, visiting arrangements and who is looking after your relative.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:specialistQuality.kch-critical-care-visitor.stages.arriving-and-getting-oriented.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-critical-care-visitor.stages.arriving-and-getting-oriented.title",
    "sourceText": "Arriving and getting oriented",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:specialistQuality.kch-critical-care-visitor.stages.arriving-and-getting-oriented.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-critical-care-visitor.stages.updates-and-support.description",
    "sourceText": "Know how the family can receive updates, what may be helpful during visits and where to find support.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:specialistQuality.kch-critical-care-visitor.stages.updates-and-support.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-critical-care-visitor.stages.updates-and-support.title",
    "sourceText": "Updates and support",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:specialistQuality.kch-critical-care-visitor.stages.updates-and-support.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-critical-care-visitor.stages.what-happens-next.description",
    "sourceText": "Understand language you may hear as care changes and what may happen when someone is ready to leave critical care.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:specialistQuality.kch-critical-care-visitor.stages.what-happens-next.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-critical-care-visitor.stages.what-happens-next.title",
    "sourceText": "What happens next",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:specialistQuality.kch-critical-care-visitor.stages.what-happens-next.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-day-surgery.stages.before-you-arrive.description",
    "sourceText": "Check your preparation, fasting, medicines, arrival information and what to bring.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-day-surgery.stages.before-you-arrive.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-day-surgery.stages.going-home.description",
    "sourceText": "Plan for discharge, transport, support at home and what to do if you have concerns.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-day-surgery.stages.going-home.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-day-surgery.stages.procedure-and-recovery.description",
    "sourceText": "Understand who may be involved and what you may wish to ask before and immediately after your procedure.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-day-surgery.stages.procedure-and-recovery.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-day-surgery.stages.procedure-and-recovery.title",
    "sourceText": "Your procedure and recovery",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-day-surgery.stages.procedure-and-recovery.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-emergency-department.stages.arrival-and-first-assessment.description",
    "sourceText": "Understand registration, initial assessment, prioritisation and what to do if you feel worse.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-emergency-department.stages.arrival-and-first-assessment.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-emergency-department.stages.assessment-and-treatment.description",
    "sourceText": "Ask about tests, medicines and what the team is considering while you are in the department.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-emergency-department.stages.assessment-and-treatment.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-emergency-department.stages.what-happens-next.description",
    "sourceText": "Understand whether you may go home, need follow-up or be admitted to hospital.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-emergency-department.stages.what-happens-next.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-imaging-diagnostics.stages.before-your-test.description",
    "sourceText": "Check preparation instructions, medicines, fasting, accessibility needs and where to go.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-imaging-diagnostics.stages.before-your-test.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-imaging-diagnostics.stages.during-your-visit.description",
    "sourceText": "Understand who may be involved and what to expect from the appointment itself.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-imaging-diagnostics.stages.during-your-visit.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-imaging-diagnostics.stages.results-and-follow-up.description",
    "sourceText": "Find out how your results will be reviewed, communicated and followed up.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-imaging-diagnostics.stages.results-and-follow-up.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-inpatient-ward.stages.during-your-stay.description",
    "sourceText": "Ask about medicines, mobility, support and the plan for your care each day.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-inpatient-ward.stages.during-your-stay.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-inpatient-ward.stages.getting-oriented.description",
    "sourceText": "Understand the ward, who is responsible for your care and who to ask if you have questions.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-inpatient-ward.stages.getting-oriented.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-inpatient-ward.stages.getting-oriented.title",
    "sourceText": "Getting oriented",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-inpatient-ward.stages.getting-oriented.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-inpatient-ward.stages.planning-for-discharge.description",
    "sourceText": "Find out what needs to happen before you leave and what support may be arranged afterwards.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-inpatient-ward.stages.planning-for-discharge.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-maternity.stages.after-birth.description",
    "sourceText": "Find support for you and your baby before and after going home.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-maternity.stages.after-birth.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-maternity.stages.during-pregnancy.description",
    "sourceText": "Understand who is coordinating your care and when other members of the maternity team may become involved.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-maternity.stages.during-pregnancy.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-maternity.stages.labour-and-birth.description",
    "sourceText": "Know when to contact the maternity team and what may happen if plans for birth change.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-maternity.stages.labour-and-birth.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-maternity.stages.preparing-for-birth.description",
    "sourceText": "Prepare for labour, discuss pain relief and understand support and visiting arrangements.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-maternity.stages.preparing-for-birth.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-outpatient-department.stages.after-your-appointment.description",
    "sourceText": "Clarify results, letters, prescriptions, follow-up and who to contact if things change.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-outpatient-department.stages.after-your-appointment.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-outpatient-department.stages.at-the-clinic.description",
    "sourceText": "Understand who you may meet, what tests may be discussed and what the next steps could be.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-outpatient-department.stages.at-the-clinic.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-outpatient-department.stages.before-your-appointment.description",
    "sourceText": "Check where to go, what to bring and any adjustments or support you may need.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:foundationQuality.kch-outpatient-department.stages.before-your-appointment.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-planned-inpatient-medical.stages.before-admission.description",
    "sourceText": "Prepare for arrival, medicines and what to bring for your planned stay.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-planned-inpatient-medical.stages.before-admission.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-planned-inpatient-medical.stages.during-your-stay.description",
    "sourceText": "Understand the plan for tests or treatment, who is coordinating your care and how to maintain independence.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-planned-inpatient-medical.stages.during-your-stay.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-planned-inpatient-medical.stages.leaving-hospital.description",
    "sourceText": "Understand discharge planning, follow-up and who to contact after you leave.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-planned-inpatient-medical.stages.leaving-hospital.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-planned-inpatient-surgery.stages.before-admission.description",
    "sourceText": "Prepare for your admission, medicines, fasting and what to bring with you.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-planned-inpatient-surgery.stages.before-admission.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-planned-inpatient-surgery.stages.planning-to-go-home.description",
    "sourceText": "Clarify discharge, support at home and who to contact if you have concerns afterwards.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-planned-inpatient-surgery.stages.planning-to-go-home.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-planned-inpatient-surgery.stages.surgery-and-ward-recovery.description",
    "sourceText": "Understand who may be involved, how pain and recovery may be supported, and what to expect on the ward.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-planned-inpatient-surgery.stages.surgery-and-ward-recovery.description"
    ]
  },
  {
    "id": "hospitalJourney:journeys.kch-planned-inpatient-surgery.stages.surgery-and-ward-recovery.title",
    "sourceText": "Surgery and ward recovery",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:broaderQuality.kch-planned-inpatient-surgery.stages.surgery-and-ward-recovery.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.nhnn-day-short-stay-surgery.roles.neurosurgeon.title",
    "sourceText": "Neurosurgeon",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:legacyJourney.nhnn-day-short-stay-surgery.roles.0.title"
    ]
  },
  {
    "id": "hospitalJourney:journeys.nhnn-surgery-operation.roles.neurosurgeon.title",
    "sourceText": "Neurosurgeon",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:legacyJourney.nhnn-surgery-operation.roles.0.title"
    ]
  },
  {
    "id": "hospitalJourney:ui.completion.compactDescription",
    "sourceText": "You do not need to open everything. Use the parts that are helpful to you and return whenever you need them.",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:specialistQuality.kch-critical-care-visitor.completion.description"
    ]
  },
  {
    "id": "hospitalJourney:ui.completion.compactTitle",
    "sourceText": "You've reached the end of this guide",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:specialistQuality.kch-critical-care-visitor.completion.title"
    ]
  },
  {
    "id": "hospitalJourney:ui.completion.summaryLabel",
    "sourceText": "Journey summary",
    "contentArea": "hospital_journeys",
    "contexts": [
      "directClinical:specialistQuality.kch-critical-care-visitor.completion.label"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.description",
    "sourceText": "An experienced registered nurse with advanced clinical skills who can assess, diagnose and treat patients within their area of practice.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.description"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.experienceNeeded",
    "sourceText": "Substantial registered nursing experience plus advanced training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.experience_needed"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.keyResponsibilities.0",
    "sourceText": "Assess patients",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.keyResponsibilities.1",
    "sourceText": "Request and interpret tests within scope",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.keyResponsibilities.2",
    "sourceText": "Diagnose and treat some conditions",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.keyResponsibilities.3",
    "sourceText": "Prescribe medicines where qualified",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.keyResponsibilities.4",
    "sourceText": "Plan and review care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.locations.1",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.locations.2",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.locations.3",
    "sourceText": "Community Settings",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.notQualifiedTo.0",
    "sourceText": "Work outside their professional competence",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.notQualifiedTo.1",
    "sourceText": "Perform procedures outside their agreed scope",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.reportsTo",
    "sourceText": "Clinical service lead or consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.reports_to"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.trainingLevel",
    "sourceText": "Registered nurse with advanced postgraduate clinical training. Prescribing depends on additional qualification and role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.training_level"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.typicalSettings.0",
    "sourceText": "Hospital wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.typicalSettings.1",
    "sourceText": "Emergency departments",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.typicalSettings.2",
    "sourceText": "Specialist clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.typicalSettings.3",
    "sourceText": "Community services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.whenYouSeeThem",
    "sourceText": "When you need an advanced assessment, diagnosis, treatment or follow-up",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.worksWith.0",
    "sourceText": "Consultants",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.works_with"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.worksWith.1",
    "sourceText": "Resident Doctors",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.works_with"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.worksWith.2",
    "sourceText": "Staff Nurses",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.works_with"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.worksWith.3",
    "sourceText": "Pharmacists",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.works_with"
    ]
  },
  {
    "id": "roles:items.advanced_nurse_practitioner.worksWith.4",
    "sourceText": "Allied Health Professionals",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.advanced_nurse_practitioner.works_with"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.description",
    "sourceText": "A specially trained professional who helps coordinate assessments under mental health law.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.description"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.experience_needed"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the approved mental health professional role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.locations.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.locations"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.locations.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.locations"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.locations.2",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.locations"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.reports_to"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.training_level"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.typicalSettings.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.typical_settings"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.typicalSettings.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.typical_settings"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.typicalSettings.2",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.typical_settings"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.whenYouSeeThem",
    "sourceText": "When you need support from a approved mental health professional; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.worksWith.0",
    "sourceText": "Psychiatrist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.works_with"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.worksWith.1",
    "sourceText": "Social Worker",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.works_with"
    ]
  },
  {
    "id": "roles:items.approved_mental_health_professional.worksWith.2",
    "sourceText": "Mental Health Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.approved_mental_health_professional.works_with"
    ]
  },
  {
    "id": "roles:items.art_therapist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.experience_needed"
    ]
  },
  {
    "id": "roles:items.art_therapist.faqs.0.answer",
    "sourceText": "No. Art therapy is not about artistic skill or producing a finished picture.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.art_therapist.faqs.0.question",
    "sourceText": "Do I need to be good at art?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.art_therapist.faqs.1.answer",
    "sourceText": "No. You decide what you want to share, and the therapist will work at a pace that feels manageable.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.art_therapist.faqs.1.question",
    "sourceText": "Will I have to explain everything I make?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.art_therapist.faqs.2.answer",
    "sourceText": "No. It is used with people of all ages.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.art_therapist.faqs.2.question",
    "sourceText": "Is art therapy only for children?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.art_therapist.keyResponsibilities.0",
    "sourceText": "Explain how art therapy works",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.art_therapist.keyResponsibilities.1",
    "sourceText": "Offer materials and therapeutic activities",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.art_therapist.keyResponsibilities.2",
    "sourceText": "Observe and discuss the creative process with your agreement",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.art_therapist.keyResponsibilities.3",
    "sourceText": "Maintain a confidential therapeutic relationship",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.art_therapist.keyResponsibilities.4",
    "sourceText": "Work with the wider team where appropriate",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.art_therapist.locations.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.locations"
    ]
  },
  {
    "id": "roles:items.art_therapist.locations.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.locations"
    ]
  },
  {
    "id": "roles:items.art_therapist.locations.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.locations"
    ]
  },
  {
    "id": "roles:items.art_therapist.locations.3",
    "sourceText": "Paediatrics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.locations"
    ]
  },
  {
    "id": "roles:items.art_therapist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.reports_to"
    ]
  },
  {
    "id": "roles:items.art_therapist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.training_level"
    ]
  },
  {
    "id": "roles:items.art_therapist.typicalSettings.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.art_therapist.typicalSettings.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.art_therapist.typicalSettings.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.art_therapist.typicalSettings.3",
    "sourceText": "Paediatrics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.art_therapist.whenYouSeeThem",
    "sourceText": "In mental health services; During rehabilitation or long-term illness; In children's, learning disability or dementia services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.art_therapist.worksWith.0",
    "sourceText": "Music Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.art_therapist.worksWith.1",
    "sourceText": "Drama Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.art_therapist.worksWith.2",
    "sourceText": "Clinical Psychologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.art_therapist.worksWith.3",
    "sourceText": "Occupational Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.art_therapist.worksWith.4",
    "sourceText": "Mental Health Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.art_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.description",
    "sourceText": "An experienced support practitioner who provides delegated care and clinical support after additional training.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.description"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.experienceNeeded",
    "sourceText": "Relevant support-worker experience and additional training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.experience_needed"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.keyResponsibilities.0",
    "sourceText": "Provide delegated clinical care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.keyResponsibilities.1",
    "sourceText": "Support assessments and rehabilitation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.keyResponsibilities.2",
    "sourceText": "Record observations and report concerns",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.keyResponsibilities.3",
    "sourceText": "Help patients with agreed care plans",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.locations.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.locations.2",
    "sourceText": "Community Settings",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.notQualifiedTo.0",
    "sourceText": "Work outside their agreed scope",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.notQualifiedTo.1",
    "sourceText": "Make independent medical diagnoses",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.reportsTo",
    "sourceText": "Registered healthcare professional",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.reports_to"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.trainingLevel",
    "sourceText": "Usually a foundation degree, apprenticeship or equivalent work-based training.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.training_level"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.typicalSettings.0",
    "sourceText": "Hospital wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.typicalSettings.1",
    "sourceText": "Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.typicalSettings.2",
    "sourceText": "Community services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.whenYouSeeThem",
    "sourceText": "When you need practical or clinical support as part of an agreed care plan",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.worksWith.0",
    "sourceText": "Registered Nurses",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.works_with"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.worksWith.1",
    "sourceText": "Nursing Associates",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.works_with"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.worksWith.2",
    "sourceText": "Healthcare Assistants",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.works_with"
    ]
  },
  {
    "id": "roles:items.assistant_practitioner.worksWith.3",
    "sourceText": "Allied Health Professionals",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.assistant_practitioner.works_with"
    ]
  },
  {
    "id": "roles:items.associate_specialist.description",
    "sourceText": "An associate specialist is a senior, experienced hospital doctor in a career-grade role. They often provide highly specialised care and may work independently within a defined scope, while collaborating with consultants and the wider team.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.description"
    ]
  },
  {
    "id": "roles:items.associate_specialist.experienceNeeded",
    "sourceText": "Medical degree, full professional registration and extensive postgraduate experience in a specialty.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.experience_needed"
    ]
  },
  {
    "id": "roles:items.associate_specialist.faqs.0.answer",
    "sourceText": "Yes. Associate specialists are qualified doctors and are usually very experienced in their field.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.faqs"
    ]
  },
  {
    "id": "roles:items.associate_specialist.faqs.0.question",
    "sourceText": "Is an associate specialist a qualified doctor?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.faqs"
    ]
  },
  {
    "id": "roles:items.associate_specialist.faqs.1.answer",
    "sourceText": "No. Associate specialist and consultant are different roles, although associate specialists may practise at a senior level within an agreed scope.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.faqs"
    ]
  },
  {
    "id": "roles:items.associate_specialist.faqs.1.question",
    "sourceText": "Are they a consultant?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.faqs"
    ]
  },
  {
    "id": "roles:items.associate_specialist.faqs.2.answer",
    "sourceText": "They may be the most appropriate senior clinician for your review and may provide greater continuity within the service.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.faqs"
    ]
  },
  {
    "id": "roles:items.associate_specialist.faqs.2.question",
    "sourceText": "Why do I see them instead of the consultant?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.faqs"
    ]
  },
  {
    "id": "roles:items.associate_specialist.keyResponsibilities.0",
    "sourceText": "Assess and manage complex patients within their expertise",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.associate_specialist.keyResponsibilities.1",
    "sourceText": "Lead clinics, ward reviews or procedure lists",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.associate_specialist.keyResponsibilities.2",
    "sourceText": "Perform specialist procedures where credentialed",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.associate_specialist.keyResponsibilities.3",
    "sourceText": "Advise and support colleagues",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.associate_specialist.keyResponsibilities.4",
    "sourceText": "Contribute to service improvement and teaching",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.associate_specialist.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.locations"
    ]
  },
  {
    "id": "roles:items.associate_specialist.locations.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.locations"
    ]
  },
  {
    "id": "roles:items.associate_specialist.notQualifiedTo.0",
    "sourceText": "Work beyond their competence or agreed scope of practice",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.associate_specialist.notQualifiedTo.1",
    "sourceText": "Replace another specialist when different expertise is required",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.associate_specialist.reportsTo",
    "sourceText": "Clinical lead or consultant, depending on local arrangements",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.reports_to"
    ]
  },
  {
    "id": "roles:items.associate_specialist.trainingLevel",
    "sourceText": "Medical degree, full professional registration and extensive postgraduate experience in a specialty.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.training_level"
    ]
  },
  {
    "id": "roles:items.associate_specialist.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.typical_settings"
    ]
  },
  {
    "id": "roles:items.associate_specialist.typicalSettings.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.typical_settings"
    ]
  },
  {
    "id": "roles:items.associate_specialist.whenYouSeeThem",
    "sourceText": "In a specialist clinic, On a ward round, During an operation or procedure",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.associate_specialist.worksWith.0",
    "sourceText": "Specialty Doctor",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.works_with"
    ]
  },
  {
    "id": "roles:items.associate_specialist.worksWith.1",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.works_with"
    ]
  },
  {
    "id": "roles:items.associate_specialist.worksWith.2",
    "sourceText": "Specialty Registrar Str",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.works_with"
    ]
  },
  {
    "id": "roles:items.associate_specialist.worksWith.3",
    "sourceText": "Resident Doctor Previously Referred To As Junior Doctor",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.associate_specialist.works_with"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.description",
    "sourceText": "Supports families with practical information and arrangements after someone dies.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.description"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.experience_needed"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the bereavement officer role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.locations"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.locations.1",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.locations"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.locations.2",
    "sourceText": "Maternity",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.locations"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.reports_to"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.training_level"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.typical_settings"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.typicalSettings.1",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.typical_settings"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.typicalSettings.2",
    "sourceText": "Maternity",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.typical_settings"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.whenYouSeeThem",
    "sourceText": "When you need support from a bereavement officer; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.worksWith.0",
    "sourceText": "Chaplain",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.works_with"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.worksWith.1",
    "sourceText": "Ward Clerk",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.works_with"
    ]
  },
  {
    "id": "roles:items.bereavement_officer.worksWith.2",
    "sourceText": "Patient Experience Officer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.bereavement_officer.works_with"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.description",
    "sourceText": "Provides practical coordination and a point of contact during cancer tests, treatment and follow-up.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.description"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.experience_needed"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the cancer care coordinator role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.locations.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.locations.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.reports_to"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.training_level"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.typicalSettings.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.typicalSettings.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.whenYouSeeThem",
    "sourceText": "When you need support from a cancer care coordinator; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.worksWith.0",
    "sourceText": "Clinical Nurse Specialist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.worksWith.1",
    "sourceText": "Patient Navigator",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.worksWith.2",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.cancer_care_coordinator.worksWith.3",
    "sourceText": "Radiographer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cancer_care_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.care_coordinator.description",
    "sourceText": "Helps organise care across different professionals and services so plans are joined up.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.description"
    ]
  },
  {
    "id": "roles:items.care_coordinator.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.experience_needed"
    ]
  },
  {
    "id": "roles:items.care_coordinator.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the care coordinator role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.care_coordinator.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.care_coordinator.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.care_coordinator.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.care_coordinator.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.care_coordinator.locations.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.care_coordinator.locations.2",
    "sourceText": "Primary Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.care_coordinator.locations.3",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.care_coordinator.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.reports_to"
    ]
  },
  {
    "id": "roles:items.care_coordinator.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.training_level"
    ]
  },
  {
    "id": "roles:items.care_coordinator.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.care_coordinator.typicalSettings.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.care_coordinator.typicalSettings.2",
    "sourceText": "Primary Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.care_coordinator.typicalSettings.3",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.care_coordinator.whenYouSeeThem",
    "sourceText": "When you need support from a care coordinator; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.care_coordinator.worksWith.0",
    "sourceText": "Patient Navigator",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.care_coordinator.worksWith.1",
    "sourceText": "Social Worker",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.care_coordinator.worksWith.2",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.care_coordinator.worksWith.3",
    "sourceText": "General Practitioner Gp",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.care_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.catering_assistant.description",
    "sourceText": "Prepares or serves food and drinks and supports patients with meal choices where appropriate.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.description"
    ]
  },
  {
    "id": "roles:items.catering_assistant.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.experience_needed"
    ]
  },
  {
    "id": "roles:items.catering_assistant.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the catering assistant role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.catering_assistant.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.catering_assistant.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.catering_assistant.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.catering_assistant.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.locations"
    ]
  },
  {
    "id": "roles:items.catering_assistant.locations.1",
    "sourceText": "Day Surgery",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.locations"
    ]
  },
  {
    "id": "roles:items.catering_assistant.locations.2",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.locations"
    ]
  },
  {
    "id": "roles:items.catering_assistant.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.reports_to"
    ]
  },
  {
    "id": "roles:items.catering_assistant.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.training_level"
    ]
  },
  {
    "id": "roles:items.catering_assistant.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.catering_assistant.typicalSettings.1",
    "sourceText": "Day Surgery",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.catering_assistant.typicalSettings.2",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.catering_assistant.whenYouSeeThem",
    "sourceText": "When you need support from a catering assistant; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.catering_assistant.worksWith.0",
    "sourceText": "Dietitian",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.works_with"
    ]
  },
  {
    "id": "roles:items.catering_assistant.worksWith.1",
    "sourceText": "Housekeeper",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.works_with"
    ]
  },
  {
    "id": "roles:items.catering_assistant.worksWith.2",
    "sourceText": "Healthcare Assistant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.catering_assistant.works_with"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.description",
    "sourceText": "Provides cognitive behavioural therapy to help you understand and change unhelpful patterns of thoughts, feelings and actions.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.description"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.experience_needed"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the cbt therapist role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.locations.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.locations"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.locations"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.locations"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.reports_to"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.training_level"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.typicalSettings.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.whenYouSeeThem",
    "sourceText": "When you need support from a cbt therapist; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.worksWith.0",
    "sourceText": "Clinical Psychologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.worksWith.1",
    "sourceText": "Psychiatrist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.cbt_therapist.worksWith.2",
    "sourceText": "Mental Health Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.cbt_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.chaplain.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.experience_needed"
    ]
  },
  {
    "id": "roles:items.chaplain.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the chaplain or spiritual care team member role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.chaplain.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.chaplain.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.chaplain.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.chaplain.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.locations"
    ]
  },
  {
    "id": "roles:items.chaplain.locations.1",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.locations"
    ]
  },
  {
    "id": "roles:items.chaplain.locations.2",
    "sourceText": "Maternity",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.locations"
    ]
  },
  {
    "id": "roles:items.chaplain.locations.3",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.locations"
    ]
  },
  {
    "id": "roles:items.chaplain.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.reports_to"
    ]
  },
  {
    "id": "roles:items.chaplain.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.training_level"
    ]
  },
  {
    "id": "roles:items.chaplain.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.typical_settings"
    ]
  },
  {
    "id": "roles:items.chaplain.typicalSettings.1",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.typical_settings"
    ]
  },
  {
    "id": "roles:items.chaplain.typicalSettings.2",
    "sourceText": "Maternity",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.typical_settings"
    ]
  },
  {
    "id": "roles:items.chaplain.typicalSettings.3",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.typical_settings"
    ]
  },
  {
    "id": "roles:items.chaplain.whenYouSeeThem",
    "sourceText": "When you need support from a chaplain or spiritual care team member; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.chaplain.worksWith.0",
    "sourceText": "Bereavement Officer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.works_with"
    ]
  },
  {
    "id": "roles:items.chaplain.worksWith.1",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.works_with"
    ]
  },
  {
    "id": "roles:items.chaplain.worksWith.2",
    "sourceText": "Patient Experience Officer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.chaplain.works_with"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.experience_needed"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.locations.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.locations.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.locations.2",
    "sourceText": "Operating Theatres",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.locations.3",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.reports_to"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.training_level"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.typicalSettings.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.typicalSettings.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.typicalSettings.2",
    "sourceText": "Operating Theatres",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_neurophysiologist.typicalSettings.3",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_neurophysiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.description",
    "sourceText": "A pharmacist who works with clinical teams to make sure your medicines are safe and suitable.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.description"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.experience_needed"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the clinical pharmacist role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.locations.2",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.reports_to"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.training_level"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.typicalSettings.2",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.whenYouSeeThem",
    "sourceText": "When you need support from a clinical pharmacist; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.worksWith.0",
    "sourceText": "Pharmacist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.works_with"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.worksWith.1",
    "sourceText": "Pharmacy Technician",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.works_with"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.worksWith.2",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.works_with"
    ]
  },
  {
    "id": "roles:items.clinical_pharmacist.worksWith.3",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_pharmacist.works_with"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.experience_needed"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.locations.0",
    "sourceText": "Laboratories",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.locations.1",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.locations.2",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.locations.3",
    "sourceText": "Research",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.locations"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.reports_to"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.training_level"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.typicalSettings.0",
    "sourceText": "Laboratories",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.typicalSettings.1",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.typicalSettings.2",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.typical_settings"
    ]
  },
  {
    "id": "roles:items.clinical_scientist.typicalSettings.3",
    "sourceText": "Research",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.clinical_scientist.typical_settings"
    ]
  },
  {
    "id": "roles:items.community_nurse.description",
    "sourceText": "A registered nurse who provides care outside hospital, often in people’s homes or community clinics.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_nurse.description"
    ]
  },
  {
    "id": "roles:items.community_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.community_nurse.locations.1",
    "sourceText": "Patients Homes",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_nurse.locations.1"
    ]
  },
  {
    "id": "roles:items.community_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.community_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.community_nurse.typicalSettings.0",
    "sourceText": "Community Settings",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.community_nurse.typicalSettings.1",
    "sourceText": "Patients Homes",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.community_nurse.typicalSettings.2",
    "sourceText": "Community Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.community_nurse.whenYouSeeThem",
    "sourceText": "A registered nurse who provides care outside hospital, often in people’s homes or community clinics.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.description",
    "sourceText": "A mental health nurse who supports people in the community and helps coordinate ongoing care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.description"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the community psychiatric nurse role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.locations.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.locations"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.locations.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.locations"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.locations.2",
    "sourceText": "Home Visits",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.locations"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.typicalSettings.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.typicalSettings.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.typicalSettings.2",
    "sourceText": "Home Visits",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.whenYouSeeThem",
    "sourceText": "When you need support from a community psychiatric nurse; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.worksWith.0",
    "sourceText": "Psychiatrist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.works_with"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.worksWith.1",
    "sourceText": "Mental Health Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.works_with"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.worksWith.2",
    "sourceText": "Social Worker",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.works_with"
    ]
  },
  {
    "id": "roles:items.community_psychiatric_nurse.worksWith.3",
    "sourceText": "General Practitioner Gp",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.community_psychiatric_nurse.works_with"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.description",
    "sourceText": "Provides psychological assessment and therapy to help with distress, relationships, life events and emotional wellbeing.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.description"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.experience_needed"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.faqs.0.answer",
    "sourceText": "Counselling psychologists complete doctoral-level psychology training and are regulated professionals. Counsellors have varied training routes.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.faqs"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.faqs.0.question",
    "sourceText": "What is the difference between a counselling psychologist and a counsellor?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.faqs"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.faqs.1.answer",
    "sourceText": "Usually not. Therapy helps you understand choices, feelings and patterns so you can make decisions that fit your circumstances.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.faqs"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.faqs.1.question",
    "sourceText": "Will they tell me what decisions to make?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.faqs"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.faqs.2.answer",
    "sourceText": "This depends on the service, your needs and the agreed plan.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.faqs"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.faqs.2.question",
    "sourceText": "How many sessions will I have?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.faqs"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.keyResponsibilities.0",
    "sourceText": "Discuss your experiences, needs and goals",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.keyResponsibilities.1",
    "sourceText": "Agree the focus and type of therapy",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.keyResponsibilities.2",
    "sourceText": "Review how therapy is progressing",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.keyResponsibilities.3",
    "sourceText": "Support practical and emotional coping",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.keyResponsibilities.4",
    "sourceText": "Explain confidentiality and safeguarding responsibilities",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.locations.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.locations"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.locations"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.locations"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.reports_to"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.training_level"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.typicalSettings.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.whenYouSeeThem",
    "sourceText": "If you are experiencing anxiety, low mood or distress; When relationships or life events are affecting wellbeing; During adjustment to illness or disability",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.worksWith.0",
    "sourceText": "Clinical Psychologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.works_with"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.worksWith.1",
    "sourceText": "Psychological Wellbeing Practitioner",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.works_with"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.worksWith.2",
    "sourceText": "Cbt Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.works_with"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.worksWith.3",
    "sourceText": "Psychiatrist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.works_with"
    ]
  },
  {
    "id": "roles:items.counselling_psychologist.worksWith.4",
    "sourceText": "Mental Health Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.counselling_psychologist.works_with"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.description",
    "sourceText": "Helps organise the practical arrangements and services needed for a safe discharge from hospital.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.description"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.experience_needed"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the discharge coordinator role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.locations.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.locations.2",
    "sourceText": "Home Visits",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.reports_to"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.training_level"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.typicalSettings.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.typicalSettings.2",
    "sourceText": "Home Visits",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.whenYouSeeThem",
    "sourceText": "When you need support from a discharge coordinator; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.worksWith.0",
    "sourceText": "Discharge Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.worksWith.1",
    "sourceText": "Social Worker",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.worksWith.2",
    "sourceText": "Care Coordinator",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.discharge_coordinator.worksWith.3",
    "sourceText": "Hospital Porter",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.discharge_nurse.description",
    "sourceText": "A nurse who helps coordinate a safe and timely move from hospital to home or another care setting.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_nurse.description"
    ]
  },
  {
    "id": "roles:items.discharge_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.discharge_nurse.locations.1",
    "sourceText": "Discharge Lounges",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_nurse.locations.1"
    ]
  },
  {
    "id": "roles:items.discharge_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.discharge_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.discharge_nurse.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.discharge_nurse.typicalSettings.1",
    "sourceText": "Discharge Lounges",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.discharge_nurse.whenYouSeeThem",
    "sourceText": "A nurse who helps coordinate a safe and timely move from hospital to home or another care setting.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.discharge_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.district_nurse.description",
    "sourceText": "A senior community nurse who leads and provides nursing care for people at home.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.district_nurse.description"
    ]
  },
  {
    "id": "roles:items.district_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.district_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.district_nurse.locations.0",
    "sourceText": "Patients Homes",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.district_nurse.locations.0"
    ]
  },
  {
    "id": "roles:items.district_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.district_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.district_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.district_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.district_nurse.typicalSettings.0",
    "sourceText": "Patients Homes",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.district_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.district_nurse.typicalSettings.1",
    "sourceText": "Community Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.district_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.district_nurse.whenYouSeeThem",
    "sourceText": "A senior community nurse who leads and provides nursing care for people at home.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.district_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.description",
    "sourceText": "Keeps patient areas clean and supports infection prevention and a safe care environment.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.description"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.experience_needed"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the domestic services assistant role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.locations"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.locations"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.locations.2",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.locations"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.locations.3",
    "sourceText": "Operating Theatres",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.locations"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.reports_to"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.training_level"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.typicalSettings.2",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.typicalSettings.3",
    "sourceText": "Operating Theatres",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.whenYouSeeThem",
    "sourceText": "When you need support from a domestic services assistant; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.worksWith.0",
    "sourceText": "Housekeeper",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.works_with"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.worksWith.1",
    "sourceText": "Infection Prevention Control Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.works_with"
    ]
  },
  {
    "id": "roles:items.domestic_services_assistant.worksWith.2",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.domestic_services_assistant.works_with"
    ]
  },
  {
    "id": "roles:items.drama_therapist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.experience_needed"
    ]
  },
  {
    "id": "roles:items.drama_therapist.faqs.0.answer",
    "sourceText": "No. Activities are adapted to your comfort and may be individual or group-based.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.drama_therapist.faqs.0.question",
    "sourceText": "Will I have to act in front of people?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.drama_therapist.faqs.1.answer",
    "sourceText": "No. The work is about therapy, not performance skill.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.drama_therapist.faqs.1.question",
    "sourceText": "Do I need drama experience?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.drama_therapist.faqs.2.answer",
    "sourceText": "No. It can support people of all ages.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.drama_therapist.faqs.2.question",
    "sourceText": "Is drama therapy only for children?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.drama_therapist.keyResponsibilities.0",
    "sourceText": "Explain and agree the purpose of therapy",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.drama_therapist.keyResponsibilities.1",
    "sourceText": "Offer structured creative activities",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.drama_therapist.keyResponsibilities.2",
    "sourceText": "Maintain a safe therapeutic environment",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.drama_therapist.keyResponsibilities.3",
    "sourceText": "Reflect on experiences with you",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.drama_therapist.keyResponsibilities.4",
    "sourceText": "Work with the wider team where appropriate",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.drama_therapist.locations.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.locations"
    ]
  },
  {
    "id": "roles:items.drama_therapist.locations.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.locations"
    ]
  },
  {
    "id": "roles:items.drama_therapist.locations.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.locations"
    ]
  },
  {
    "id": "roles:items.drama_therapist.locations.3",
    "sourceText": "Paediatrics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.locations"
    ]
  },
  {
    "id": "roles:items.drama_therapist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.reports_to"
    ]
  },
  {
    "id": "roles:items.drama_therapist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.training_level"
    ]
  },
  {
    "id": "roles:items.drama_therapist.typicalSettings.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.drama_therapist.typicalSettings.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.drama_therapist.typicalSettings.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.drama_therapist.typicalSettings.3",
    "sourceText": "Paediatrics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.drama_therapist.whenYouSeeThem",
    "sourceText": "In mental health or learning disability services; In children's and young people's services; During rehabilitation or trauma support",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.drama_therapist.worksWith.0",
    "sourceText": "Art Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.drama_therapist.worksWith.1",
    "sourceText": "Music Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.drama_therapist.worksWith.2",
    "sourceText": "Clinical Psychologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.drama_therapist.worksWith.3",
    "sourceText": "Occupational Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.drama_therapist.worksWith.4",
    "sourceText": "Mental Health Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.drama_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.endoscopy_practitioner.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.endoscopy_practitioner.experience_needed"
    ]
  },
  {
    "id": "roles:items.endoscopy_practitioner.locations.0",
    "sourceText": "Day Surgery",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.endoscopy_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.endoscopy_practitioner.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.endoscopy_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.endoscopy_practitioner.locations.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.endoscopy_practitioner.locations"
    ]
  },
  {
    "id": "roles:items.endoscopy_practitioner.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.endoscopy_practitioner.reports_to"
    ]
  },
  {
    "id": "roles:items.endoscopy_practitioner.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.endoscopy_practitioner.training_level"
    ]
  },
  {
    "id": "roles:items.endoscopy_practitioner.typicalSettings.0",
    "sourceText": "Day Surgery",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.endoscopy_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.endoscopy_practitioner.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.endoscopy_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.endoscopy_practitioner.typicalSettings.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.endoscopy_practitioner.typical_settings"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.experience_needed"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.faqs.0.answer",
    "sourceText": "No. Clinical exercise physiologists use specialist healthcare knowledge to assess and support people with medical conditions.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.faqs"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.faqs.0.question",
    "sourceText": "Is this the same as a personal trainer?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.faqs"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.faqs.1.answer",
    "sourceText": "Tell the professional immediately. They will explain expected symptoms, safety limits and when to stop.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.faqs"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.faqs.1.question",
    "sourceText": "What if exercise makes me breathless or causes pain?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.faqs"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.faqs.2.answer",
    "sourceText": "Often the aim is to help you continue safely outside supervised sessions, with a plan suited to you.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.faqs"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.faqs.2.question",
    "sourceText": "Will I need to exercise independently?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.faqs"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.keyResponsibilities.0",
    "sourceText": "Review your health, activity and goals",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.keyResponsibilities.1",
    "sourceText": "Measure fitness or exercise responses",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.keyResponsibilities.2",
    "sourceText": "Teach and supervise suitable exercises",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.keyResponsibilities.3",
    "sourceText": "Adapt programmes around symptoms or limitations",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.keyResponsibilities.4",
    "sourceText": "Work with medical and therapy teams",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.locations.0",
    "sourceText": "Rehabilitation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.reports_to"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.training_level"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.typicalSettings.0",
    "sourceText": "Rehabilitation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.whenYouSeeThem",
    "sourceText": "During cardiac or pulmonary rehabilitation; After illness or treatment that has reduced fitness; In long-term condition or weight-management services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.worksWith.0",
    "sourceText": "Physiotherapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.works_with"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.worksWith.1",
    "sourceText": "Cardiac Physiologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.works_with"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.worksWith.2",
    "sourceText": "Respiratory Physiologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.works_with"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.worksWith.3",
    "sourceText": "Dietitian",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.works_with"
    ]
  },
  {
    "id": "roles:items.exercise_physiologist.worksWith.4",
    "sourceText": "Physician",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.exercise_physiologist.works_with"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.description",
    "sourceText": "A foundation doctor is a qualified doctor in the first two years of postgraduate practice. They provide supervised day-to-day medical care while building broad experience across different specialties.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.description"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.experienceNeeded",
    "sourceText": "Medical degree followed by the two-year UK Foundation Programme, with supervised workplace learning and assessment.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.experience_needed"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.faqs.0.answer",
    "sourceText": "Yes. They have completed medical school and are working as registered doctors, with supervision appropriate to their stage of experience.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.faqs.0.question",
    "sourceText": "Are foundation doctors fully qualified?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.faqs.1.answer",
    "sourceText": "Foundation doctors regularly discuss decisions with registrars, specialty doctors or consultants. This is a normal part of safe team-based care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.faqs.1.question",
    "sourceText": "Why might they check with another doctor?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.faqs.2.answer",
    "sourceText": "Yes, within their competence and local arrangements. They seek senior advice for unfamiliar, complex or high-risk decisions.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.faqs.2.question",
    "sourceText": "Can they prescribe medicines?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.keyResponsibilities.0",
    "sourceText": "Assess symptoms and examine patients",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.keyResponsibilities.1",
    "sourceText": "Request and review common tests",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.keyResponsibilities.2",
    "sourceText": "Prescribe medicines within their competence",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.keyResponsibilities.3",
    "sourceText": "Update medical records and care plans",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.keyResponsibilities.4",
    "sourceText": "Discuss concerns with more senior doctors",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.locations"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.locations.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.locations"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.notQualifiedTo.0",
    "sourceText": "Work beyond their competence or agreed scope of practice",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.notQualifiedTo.1",
    "sourceText": "Replace another specialist when different expertise is required",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.reportsTo",
    "sourceText": "Registrar, specialty doctor or consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.reports_to"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.trainingLevel",
    "sourceText": "Medical degree followed by the two-year UK Foundation Programme, with supervised workplace learning and assessment.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.training_level"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.typical_settings"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.typicalSettings.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.typical_settings"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.whenYouSeeThem",
    "sourceText": "When you are admitted to hospital, During ward rounds, When your symptoms or routine checks, such as blood pressure or pulse, change",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.worksWith.0",
    "sourceText": "Resident Doctor Previously Referred To As Junior Doctor",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.works_with"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.worksWith.1",
    "sourceText": "Specialty Registrar Str",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.works_with"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.worksWith.2",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.works_with"
    ]
  },
  {
    "id": "roles:items.foundation_doctor.worksWith.3",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.foundation_doctor.works_with"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.description",
    "sourceText": "A general practitioner, usually called a GP, is a doctor who provides first-contact and continuing care in the community. They assess a wide range of concerns, manage long-term conditions and refer people to other services when needed.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.description"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.experienceNeeded",
    "sourceText": "Medical degree, Foundation Programme and approved specialist training in general practice, followed by GP registration.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.experience_needed"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.faqs.0.answer",
    "sourceText": "Yes. A GP can refer you for specialist assessment, tests or treatment when this is clinically appropriate.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.faqs"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.faqs.0.question",
    "sourceText": "Can a GP refer me to hospital?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.faqs"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.faqs.1.answer",
    "sourceText": "The GP may need complete information, check monitoring requirements or clarify who is responsible for prescribing. You can ask how the plan will be coordinated.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.faqs"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.faqs.1.question",
    "sourceText": "Why might my GP not prescribe what the hospital suggested immediately?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.faqs"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.faqs.2.answer",
    "sourceText": "Practices try to support continuity where possible, especially for ongoing or complex needs, but availability varies.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.faqs"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.faqs.2.question",
    "sourceText": "Can I see the same GP each time?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.faqs"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.keyResponsibilities.0",
    "sourceText": "Assess new symptoms and health concerns",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.keyResponsibilities.1",
    "sourceText": "Diagnose and treat many common conditions",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.keyResponsibilities.2",
    "sourceText": "Manage long-term health conditions",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.keyResponsibilities.3",
    "sourceText": "Prescribe and review medicines",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.keyResponsibilities.4",
    "sourceText": "Refer to hospital or community specialists when appropriate",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.locations"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.locations.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.locations"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.locations.2",
    "sourceText": "Community Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.locations"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.notQualifiedTo.0",
    "sourceText": "Work beyond their competence or agreed scope of practice",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.notQualifiedTo.1",
    "sourceText": "Replace another specialist when different expertise is required",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.reportsTo",
    "sourceText": "Independent clinician within a GP practice or service",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.reports_to"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.trainingLevel",
    "sourceText": "Medical degree, Foundation Programme and approved specialist training in general practice, followed by GP registration.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.training_level"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.typical_settings"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.typicalSettings.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.typical_settings"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.whenYouSeeThem",
    "sourceText": "At your GP surgery, During a telephone or video consultation, At home, in some circumstances",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.worksWith.0",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.works_with"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.worksWith.1",
    "sourceText": "Pharmacist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.works_with"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.worksWith.2",
    "sourceText": "Community Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.works_with"
    ]
  },
  {
    "id": "roles:items.general_practitioner_gp.worksWith.3",
    "sourceText": "Physician Associate",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.general_practitioner_gp.works_with"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.description",
    "sourceText": "Gives practical help, information or companionship as part of an approved hospital volunteer service.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.description"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.experience_needed"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the hospital volunteer role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.locations"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.locations"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.locations"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.reports_to"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.training_level"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.typical_settings"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.typical_settings"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.typical_settings"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.whenYouSeeThem",
    "sourceText": "When you need support from a hospital volunteer; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.worksWith.0",
    "sourceText": "Receptionist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.works_with"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.worksWith.1",
    "sourceText": "Patient Experience Officer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.works_with"
    ]
  },
  {
    "id": "roles:items.hospital_volunteer.worksWith.2",
    "sourceText": "Chaplain",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.hospital_volunteer.works_with"
    ]
  },
  {
    "id": "roles:items.housekeeper.description",
    "sourceText": "Helps keep a ward or clinical area clean, organised, stocked and comfortable for patients.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.description"
    ]
  },
  {
    "id": "roles:items.housekeeper.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.experience_needed"
    ]
  },
  {
    "id": "roles:items.housekeeper.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the housekeeper role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.housekeeper.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.housekeeper.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.housekeeper.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.housekeeper.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.locations"
    ]
  },
  {
    "id": "roles:items.housekeeper.locations.1",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.locations"
    ]
  },
  {
    "id": "roles:items.housekeeper.locations.2",
    "sourceText": "Day Surgery",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.locations"
    ]
  },
  {
    "id": "roles:items.housekeeper.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.reports_to"
    ]
  },
  {
    "id": "roles:items.housekeeper.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.training_level"
    ]
  },
  {
    "id": "roles:items.housekeeper.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.typical_settings"
    ]
  },
  {
    "id": "roles:items.housekeeper.typicalSettings.1",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.typical_settings"
    ]
  },
  {
    "id": "roles:items.housekeeper.typicalSettings.2",
    "sourceText": "Day Surgery",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.typical_settings"
    ]
  },
  {
    "id": "roles:items.housekeeper.whenYouSeeThem",
    "sourceText": "When you need support from a housekeeper; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.housekeeper.worksWith.0",
    "sourceText": "Domestic Services Assistant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.works_with"
    ]
  },
  {
    "id": "roles:items.housekeeper.worksWith.1",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.works_with"
    ]
  },
  {
    "id": "roles:items.housekeeper.worksWith.2",
    "sourceText": "Ward Clerk",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.housekeeper.works_with"
    ]
  },
  {
    "id": "roles:items.imaging_assistant.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.imaging_assistant.experience_needed"
    ]
  },
  {
    "id": "roles:items.imaging_assistant.locations.0",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.imaging_assistant.locations"
    ]
  },
  {
    "id": "roles:items.imaging_assistant.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.imaging_assistant.locations"
    ]
  },
  {
    "id": "roles:items.imaging_assistant.locations.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.imaging_assistant.locations"
    ]
  },
  {
    "id": "roles:items.imaging_assistant.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.imaging_assistant.reports_to"
    ]
  },
  {
    "id": "roles:items.imaging_assistant.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.imaging_assistant.training_level"
    ]
  },
  {
    "id": "roles:items.imaging_assistant.typicalSettings.0",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.imaging_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.imaging_assistant.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.imaging_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.imaging_assistant.typicalSettings.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.imaging_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.infection_prevention_control_nurse.description",
    "sourceText": "A specialist nurse who helps prevent and manage infections in healthcare settings.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.infection_prevention_control_nurse.description"
    ]
  },
  {
    "id": "roles:items.infection_prevention_control_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.infection_prevention_control_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.infection_prevention_control_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.infection_prevention_control_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.infection_prevention_control_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.infection_prevention_control_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.infection_prevention_control_nurse.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.infection_prevention_control_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.infection_prevention_control_nurse.typicalSettings.1",
    "sourceText": "Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.infection_prevention_control_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.infection_prevention_control_nurse.typicalSettings.2",
    "sourceText": "Community Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.infection_prevention_control_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.infection_prevention_control_nurse.whenYouSeeThem",
    "sourceText": "A specialist nurse who helps prevent and manage infections in healthcare settings.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.infection_prevention_control_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.interpreter.description",
    "sourceText": "Helps you and the healthcare team communicate accurately when you prefer another spoken or signed language.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.description"
    ]
  },
  {
    "id": "roles:items.interpreter.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.experience_needed"
    ]
  },
  {
    "id": "roles:items.interpreter.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the interpreter role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.interpreter.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.interpreter.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.interpreter.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.interpreter.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.locations"
    ]
  },
  {
    "id": "roles:items.interpreter.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.locations"
    ]
  },
  {
    "id": "roles:items.interpreter.locations.2",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.locations"
    ]
  },
  {
    "id": "roles:items.interpreter.locations.3",
    "sourceText": "Maternity",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.locations"
    ]
  },
  {
    "id": "roles:items.interpreter.locations.4",
    "sourceText": "Primary Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.locations"
    ]
  },
  {
    "id": "roles:items.interpreter.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.reports_to"
    ]
  },
  {
    "id": "roles:items.interpreter.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.training_level"
    ]
  },
  {
    "id": "roles:items.interpreter.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.typical_settings"
    ]
  },
  {
    "id": "roles:items.interpreter.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.typical_settings"
    ]
  },
  {
    "id": "roles:items.interpreter.typicalSettings.2",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.typical_settings"
    ]
  },
  {
    "id": "roles:items.interpreter.typicalSettings.3",
    "sourceText": "Maternity",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.typical_settings"
    ]
  },
  {
    "id": "roles:items.interpreter.typicalSettings.4",
    "sourceText": "Primary Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.typical_settings"
    ]
  },
  {
    "id": "roles:items.interpreter.whenYouSeeThem",
    "sourceText": "When you need support from a interpreter; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.interpreter.worksWith.0",
    "sourceText": "Receptionist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.works_with"
    ]
  },
  {
    "id": "roles:items.interpreter.worksWith.1",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.works_with"
    ]
  },
  {
    "id": "roles:items.interpreter.worksWith.2",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.interpreter.works_with"
    ]
  },
  {
    "id": "roles:items.mammographer.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.mammographer.experience_needed"
    ]
  },
  {
    "id": "roles:items.mammographer.locations.0",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.mammographer.locations"
    ]
  },
  {
    "id": "roles:items.mammographer.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.mammographer.locations"
    ]
  },
  {
    "id": "roles:items.mammographer.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.mammographer.reports_to"
    ]
  },
  {
    "id": "roles:items.mammographer.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.mammographer.training_level"
    ]
  },
  {
    "id": "roles:items.mammographer.typicalSettings.0",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.mammographer.typical_settings"
    ]
  },
  {
    "id": "roles:items.mammographer.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.mammographer.typical_settings"
    ]
  },
  {
    "id": "roles:items.maternity_support_worker.description",
    "sourceText": "A support worker who assists midwives and families during maternity care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.maternity_support_worker.description"
    ]
  },
  {
    "id": "roles:items.maternity_support_worker.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.maternity_support_worker.experience_needed"
    ]
  },
  {
    "id": "roles:items.maternity_support_worker.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.maternity_support_worker.reports_to"
    ]
  },
  {
    "id": "roles:items.maternity_support_worker.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.maternity_support_worker.training_level"
    ]
  },
  {
    "id": "roles:items.maternity_support_worker.typicalSettings.0",
    "sourceText": "Maternity Units",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.maternity_support_worker.typical_settings"
    ]
  },
  {
    "id": "roles:items.maternity_support_worker.typicalSettings.1",
    "sourceText": "Community Settings",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.maternity_support_worker.typical_settings"
    ]
  },
  {
    "id": "roles:items.maternity_support_worker.whenYouSeeThem",
    "sourceText": "A support worker who assists midwives and families during maternity care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.maternity_support_worker.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.description",
    "sourceText": "Helps check your usual medicines and supports safe medicine use during admission and discharge.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.description"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.experience_needed"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the medicines management technician role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.locations"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.locations"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.reports_to"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.training_level"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.typical_settings"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.typical_settings"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.whenYouSeeThem",
    "sourceText": "When you need support from a medicines management technician; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.worksWith.0",
    "sourceText": "Pharmacist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.works_with"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.worksWith.1",
    "sourceText": "Pharmacy Technician",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.works_with"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.worksWith.2",
    "sourceText": "Discharge Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.works_with"
    ]
  },
  {
    "id": "roles:items.medicines_management_technician.worksWith.3",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.medicines_management_technician.works_with"
    ]
  },
  {
    "id": "roles:items.music_therapist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.experience_needed"
    ]
  },
  {
    "id": "roles:items.music_therapist.faqs.0.answer",
    "sourceText": "No. Music therapy does not require musical skill.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.music_therapist.faqs.0.question",
    "sourceText": "Do I need musical experience?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.music_therapist.faqs.1.answer",
    "sourceText": "No. Sessions are therapeutic, not performances, and activities are adapted to you.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.music_therapist.faqs.1.question",
    "sourceText": "Will I have to perform?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.music_therapist.faqs.2.answer",
    "sourceText": "It may provide another way to communicate and connect, depending on your needs.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.music_therapist.faqs.2.question",
    "sourceText": "Can music therapy help if I cannot speak?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.faqs"
    ]
  },
  {
    "id": "roles:items.music_therapist.keyResponsibilities.0",
    "sourceText": "Assess how music may support your goals",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.music_therapist.keyResponsibilities.1",
    "sourceText": "Use listening, instruments, voice or improvisation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.music_therapist.keyResponsibilities.2",
    "sourceText": "Adapt activities to your abilities and preferences",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.music_therapist.keyResponsibilities.3",
    "sourceText": "Observe responses and review progress",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.music_therapist.keyResponsibilities.4",
    "sourceText": "Coordinate with the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.music_therapist.locations.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.locations"
    ]
  },
  {
    "id": "roles:items.music_therapist.locations.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.locations"
    ]
  },
  {
    "id": "roles:items.music_therapist.locations.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.locations"
    ]
  },
  {
    "id": "roles:items.music_therapist.locations.3",
    "sourceText": "Paediatrics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.locations"
    ]
  },
  {
    "id": "roles:items.music_therapist.locations.4",
    "sourceText": "Rehabilitation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.locations"
    ]
  },
  {
    "id": "roles:items.music_therapist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.reports_to"
    ]
  },
  {
    "id": "roles:items.music_therapist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.training_level"
    ]
  },
  {
    "id": "roles:items.music_therapist.typicalSettings.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.music_therapist.typicalSettings.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.music_therapist.typicalSettings.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.music_therapist.typicalSettings.3",
    "sourceText": "Paediatrics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.music_therapist.typicalSettings.4",
    "sourceText": "Rehabilitation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.typical_settings"
    ]
  },
  {
    "id": "roles:items.music_therapist.whenYouSeeThem",
    "sourceText": "In neurological rehabilitation; In mental health, dementia or learning disability services; In children's or palliative care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.music_therapist.worksWith.0",
    "sourceText": "Art Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.music_therapist.worksWith.1",
    "sourceText": "Drama Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.music_therapist.worksWith.2",
    "sourceText": "Speech and Language Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.music_therapist.worksWith.3",
    "sourceText": "Clinical Psychologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.music_therapist.worksWith.4",
    "sourceText": "Occupational Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.music_therapist.works_with"
    ]
  },
  {
    "id": "roles:items.neonatal_nurse.description",
    "sourceText": "A registered nurse who cares for newborn babies who need specialist or intensive support.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.neonatal_nurse.description"
    ]
  },
  {
    "id": "roles:items.neonatal_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.neonatal_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.neonatal_nurse.locations.0",
    "sourceText": "Neonatal Units",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.neonatal_nurse.locations.0"
    ]
  },
  {
    "id": "roles:items.neonatal_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.neonatal_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.neonatal_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.neonatal_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.neonatal_nurse.typicalSettings.0",
    "sourceText": "Neonatal Units",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.neonatal_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.neonatal_nurse.typicalSettings.1",
    "sourceText": "Maternity Units",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.neonatal_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.neonatal_nurse.whenYouSeeThem",
    "sourceText": "A registered nurse who cares for newborn babies who need specialist or intensive support.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.neonatal_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.orthotist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.experience_needed"
    ]
  },
  {
    "id": "roles:items.orthotist.faqs.0.answer",
    "sourceText": "An orthosis is a brace, splint, insole or other device worn to support or guide part of the body.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.faqs"
    ]
  },
  {
    "id": "roles:items.orthotist.faqs.0.question",
    "sourceText": "What is an orthosis?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.faqs"
    ]
  },
  {
    "id": "roles:items.orthotist.faqs.1.answer",
    "sourceText": "Stop or reduce use as advised and contact the service. Persistent rubbing or skin damage needs review.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.faqs"
    ]
  },
  {
    "id": "roles:items.orthotist.faqs.1.question",
    "sourceText": "What should I do if it rubs or causes pain?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.faqs"
    ]
  },
  {
    "id": "roles:items.orthotist.faqs.2.answer",
    "sourceText": "They are related professions. Orthotists provide supportive devices for existing limbs or the spine; prosthetists provide artificial limbs.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.faqs"
    ]
  },
  {
    "id": "roles:items.orthotist.faqs.2.question",
    "sourceText": "Is an orthotist the same as a prosthetist?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.faqs"
    ]
  },
  {
    "id": "roles:items.orthotist.keyResponsibilities.0",
    "sourceText": "Assess posture, movement, skin and symptoms",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.orthotist.keyResponsibilities.1",
    "sourceText": "Explain the purpose of an orthosis",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.orthotist.keyResponsibilities.2",
    "sourceText": "Arrange standard or custom-made devices",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.orthotist.keyResponsibilities.3",
    "sourceText": "Teach you how and when to use the device",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.orthotist.keyResponsibilities.4",
    "sourceText": "Monitor fit, comfort and effectiveness",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.orthotist.locations.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.locations"
    ]
  },
  {
    "id": "roles:items.orthotist.locations.1",
    "sourceText": "Rehabilitation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.locations"
    ]
  },
  {
    "id": "roles:items.orthotist.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.locations"
    ]
  },
  {
    "id": "roles:items.orthotist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.reports_to"
    ]
  },
  {
    "id": "roles:items.orthotist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.training_level"
    ]
  },
  {
    "id": "roles:items.orthotist.typicalSettings.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.typical_settings"
    ]
  },
  {
    "id": "roles:items.orthotist.typicalSettings.1",
    "sourceText": "Rehabilitation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.typical_settings"
    ]
  },
  {
    "id": "roles:items.orthotist.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.typical_settings"
    ]
  },
  {
    "id": "roles:items.orthotist.whenYouSeeThem",
    "sourceText": "If you need support for a joint, limb or spine; After injury, surgery or neurological illness; In diabetic foot or mobility services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.orthotist.worksWith.0",
    "sourceText": "Prosthetist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.works_with"
    ]
  },
  {
    "id": "roles:items.orthotist.worksWith.1",
    "sourceText": "Physiotherapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.works_with"
    ]
  },
  {
    "id": "roles:items.orthotist.worksWith.2",
    "sourceText": "Podiatrist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.works_with"
    ]
  },
  {
    "id": "roles:items.orthotist.worksWith.3",
    "sourceText": "Occupational Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.works_with"
    ]
  },
  {
    "id": "roles:items.orthotist.worksWith.4",
    "sourceText": "Surgeon",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.orthotist.works_with"
    ]
  },
  {
    "id": "roles:items.paediatrician.description",
    "sourceText": "A paediatrician is a doctor who specialises in the health of babies, children and young people. They assess illness, development and longer-term health needs while involving parents, carers and the young person in decisions.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.description"
    ]
  },
  {
    "id": "roles:items.paediatrician.experienceNeeded",
    "sourceText": "Medical degree followed by postgraduate training in paediatrics and child health.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.experience_needed"
    ]
  },
  {
    "id": "roles:items.paediatrician.faqs.0.answer",
    "sourceText": "They care for babies, children and young people. Exact age limits vary between services and may extend into young adulthood for some conditions.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.faqs"
    ]
  },
  {
    "id": "roles:items.paediatrician.faqs.0.question",
    "sourceText": "What ages do paediatricians care for?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.faqs"
    ]
  },
  {
    "id": "roles:items.paediatrician.faqs.1.answer",
    "sourceText": "Yes. Children and young people should receive explanations they can understand and be involved according to their age, understanding and circumstances.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.faqs"
    ]
  },
  {
    "id": "roles:items.paediatrician.faqs.1.question",
    "sourceText": "Will my child be involved in decisions?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.faqs"
    ]
  },
  {
    "id": "roles:items.paediatrician.faqs.2.answer",
    "sourceText": "Services usually encourage family involvement, although arrangements vary by setting and clinical need.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.faqs"
    ]
  },
  {
    "id": "roles:items.paediatrician.faqs.2.question",
    "sourceText": "Can a parent or carer stay with the child?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.faqs"
    ]
  },
  {
    "id": "roles:items.paediatrician.keyResponsibilities.0",
    "sourceText": "Assess illnesses and injuries in children",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.paediatrician.keyResponsibilities.1",
    "sourceText": "Monitor growth and development",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.paediatrician.keyResponsibilities.2",
    "sourceText": "Manage acute and long-term conditions",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.paediatrician.keyResponsibilities.3",
    "sourceText": "Request and interpret child-specific tests",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.paediatrician.keyResponsibilities.4",
    "sourceText": "Coordinate with families, schools and specialist services when appropriate",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.paediatrician.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.locations"
    ]
  },
  {
    "id": "roles:items.paediatrician.locations.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.locations"
    ]
  },
  {
    "id": "roles:items.paediatrician.notQualifiedTo.0",
    "sourceText": "Work beyond their competence or agreed scope of practice",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.paediatrician.notQualifiedTo.1",
    "sourceText": "Replace another specialist when different expertise is required",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.paediatrician.reportsTo",
    "sourceText": "Consultant or clinical lead, depending on grade and role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.reports_to"
    ]
  },
  {
    "id": "roles:items.paediatrician.trainingLevel",
    "sourceText": "Medical degree followed by postgraduate training in paediatrics and child health.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.training_level"
    ]
  },
  {
    "id": "roles:items.paediatrician.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.typical_settings"
    ]
  },
  {
    "id": "roles:items.paediatrician.typicalSettings.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.typical_settings"
    ]
  },
  {
    "id": "roles:items.paediatrician.whenYouSeeThem",
    "sourceText": "On a children’s ward, In a paediatric clinic, In the emergency department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.paediatrician.worksWith.0",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.works_with"
    ]
  },
  {
    "id": "roles:items.paediatrician.worksWith.1",
    "sourceText": "Resident Doctor Previously Referred To As Junior Doctor",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.works_with"
    ]
  },
  {
    "id": "roles:items.paediatrician.worksWith.2",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.works_with"
    ]
  },
  {
    "id": "roles:items.paediatrician.worksWith.3",
    "sourceText": "Health Visitor",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.paediatrician.works_with"
    ]
  },
  {
    "id": "roles:items.pathologist.description",
    "sourceText": "A pathologist is a doctor who helps diagnose disease by examining tissues, cells, blood or other samples and interpreting laboratory information. Many work mainly behind the scenes with clinical and laboratory teams.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.description"
    ]
  },
  {
    "id": "roles:items.pathologist.experienceNeeded",
    "sourceText": "Medical degree followed by specialist postgraduate training in a pathology discipline.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.experience_needed"
    ]
  },
  {
    "id": "roles:items.pathologist.faqs.0.answer",
    "sourceText": "No. Most pathology supports diagnosis and treatment in living patients. Post-mortem pathology is only one part of the specialty.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.faqs"
    ]
  },
  {
    "id": "roles:items.pathologist.faqs.0.question",
    "sourceText": "Is a pathologist always involved after someone dies?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.faqs"
    ]
  },
  {
    "id": "roles:items.pathologist.faqs.1.answer",
    "sourceText": "Often not. The pathologist usually sends a report to the clinician responsible for discussing the result with you.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.faqs"
    ]
  },
  {
    "id": "roles:items.pathologist.faqs.1.question",
    "sourceText": "Will I meet the pathologist who examines my sample?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.faqs"
    ]
  },
  {
    "id": "roles:items.pathologist.faqs.2.answer",
    "sourceText": "No. They are different regulated professionals who work closely together in laboratory services. Pathologists are doctors; biomedical scientists perform and interpret a wide range of laboratory investigations within their scope.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.faqs"
    ]
  },
  {
    "id": "roles:items.pathologist.faqs.2.question",
    "sourceText": "Is a biomedical scientist the same as a pathologist?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.faqs"
    ]
  },
  {
    "id": "roles:items.pathologist.keyResponsibilities.0",
    "sourceText": "Examine tissue and cell samples",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.pathologist.keyResponsibilities.1",
    "sourceText": "Interpret complex laboratory findings",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.pathologist.keyResponsibilities.2",
    "sourceText": "Confirm or refine diagnoses",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.pathologist.keyResponsibilities.3",
    "sourceText": "Advise clinical teams about further tests",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.pathologist.keyResponsibilities.4",
    "sourceText": "Contribute to cancer meetings, post-mortem examinations or specialist laboratory services depending on their field",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.pathologist.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.locations"
    ]
  },
  {
    "id": "roles:items.pathologist.locations.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.locations"
    ]
  },
  {
    "id": "roles:items.pathologist.notQualifiedTo.0",
    "sourceText": "Work beyond their competence or agreed scope of practice",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.pathologist.notQualifiedTo.1",
    "sourceText": "Replace another specialist when different expertise is required",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.pathologist.reportsTo",
    "sourceText": "Clinical director or pathology clinical lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.reports_to"
    ]
  },
  {
    "id": "roles:items.pathologist.trainingLevel",
    "sourceText": "Medical degree followed by specialist postgraduate training in a pathology discipline.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.training_level"
    ]
  },
  {
    "id": "roles:items.pathologist.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.pathologist.typicalSettings.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.pathologist.whenYouSeeThem",
    "sourceText": "You may not meet them directly, When a tissue sample or biopsy is examined, During a specialist clinic in some pathology fields",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.pathologist.worksWith.0",
    "sourceText": "Biomedical Scientist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.works_with"
    ]
  },
  {
    "id": "roles:items.pathologist.worksWith.1",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.works_with"
    ]
  },
  {
    "id": "roles:items.pathologist.worksWith.2",
    "sourceText": "Surgeon",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.works_with"
    ]
  },
  {
    "id": "roles:items.pathologist.worksWith.3",
    "sourceText": "Physician",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pathologist.works_with"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.description",
    "sourceText": "Provides information, listens to concerns and helps patients navigate feedback or local support.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.description"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.experience_needed"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the patient experience or pals officer role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.locations"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.locations"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.locations"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.reports_to"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.training_level"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.whenYouSeeThem",
    "sourceText": "When you need support from a patient experience or pals officer; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.worksWith.0",
    "sourceText": "Receptionist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.works_with"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.worksWith.1",
    "sourceText": "Care Coordinator",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.works_with"
    ]
  },
  {
    "id": "roles:items.patient_experience_officer.worksWith.2",
    "sourceText": "Hospital Volunteer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_experience_officer.works_with"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.description",
    "sourceText": "Helps teams organise beds, transfers and discharge so patients can move safely through hospital care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.description"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.experience_needed"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the patient flow coordinator role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.locations.1",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.locations.2",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.locations"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.reports_to"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.training_level"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.typicalSettings.1",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.typicalSettings.2",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.whenYouSeeThem",
    "sourceText": "When you need support from a patient flow coordinator; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.worksWith.0",
    "sourceText": "Ward Sister Charge Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.worksWith.1",
    "sourceText": "Discharge Coordinator",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.worksWith.2",
    "sourceText": "Hospital Porter",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.patient_flow_coordinator.worksWith.3",
    "sourceText": "Ward Clerk",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_flow_coordinator.works_with"
    ]
  },
  {
    "id": "roles:items.patient_navigator.description",
    "sourceText": "Helps you understand where to go, what happens next and who to contact during your care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.description"
    ]
  },
  {
    "id": "roles:items.patient_navigator.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.experience_needed"
    ]
  },
  {
    "id": "roles:items.patient_navigator.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the patient navigator role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_navigator.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_navigator.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_navigator.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_navigator.locations.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.locations"
    ]
  },
  {
    "id": "roles:items.patient_navigator.locations.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.locations"
    ]
  },
  {
    "id": "roles:items.patient_navigator.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.locations"
    ]
  },
  {
    "id": "roles:items.patient_navigator.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.reports_to"
    ]
  },
  {
    "id": "roles:items.patient_navigator.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.training_level"
    ]
  },
  {
    "id": "roles:items.patient_navigator.typicalSettings.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_navigator.typicalSettings.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_navigator.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_navigator.whenYouSeeThem",
    "sourceText": "When you need support from a patient navigator; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.patient_navigator.worksWith.0",
    "sourceText": "Care Coordinator",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.works_with"
    ]
  },
  {
    "id": "roles:items.patient_navigator.worksWith.1",
    "sourceText": "Receptionist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.works_with"
    ]
  },
  {
    "id": "roles:items.patient_navigator.worksWith.2",
    "sourceText": "Patient Experience Officer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_navigator.works_with"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.description",
    "sourceText": "Transports eligible patients safely to and from healthcare appointments or between care sites.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.description"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.experience_needed"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the patient transport driver role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.locations.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.locations"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.locations.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.locations"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.locations"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.reports_to"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.training_level"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.typicalSettings.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.typicalSettings.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.typical_settings"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.whenYouSeeThem",
    "sourceText": "When you need support from a patient transport driver; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.worksWith.0",
    "sourceText": "Hospital Porter",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.works_with"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.worksWith.1",
    "sourceText": "Receptionist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.works_with"
    ]
  },
  {
    "id": "roles:items.patient_transport_driver.worksWith.2",
    "sourceText": "Discharge Coordinator",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.patient_transport_driver.works_with"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.description",
    "sourceText": "Uses personal experience of health challenges or recovery to offer practical and emotional support.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.description"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.experience_needed"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the peer support worker role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.locations.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.locations"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.locations.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.locations"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.locations.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.locations"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.reports_to"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.training_level"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.typicalSettings.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.typical_settings"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.typicalSettings.1",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.typical_settings"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.typicalSettings.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.typical_settings"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.whenYouSeeThem",
    "sourceText": "When you need support from a peer support worker; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.worksWith.0",
    "sourceText": "Mental Health Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.works_with"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.worksWith.1",
    "sourceText": "Social Worker",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.works_with"
    ]
  },
  {
    "id": "roles:items.peer_support_worker.worksWith.2",
    "sourceText": "Clinical Psychologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.peer_support_worker.works_with"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.description",
    "sourceText": "Supports the pharmacy team with preparing, supplying and organising medicines.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.description"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.experience_needed"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the pharmacy assistant role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.locations"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.locations"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.reports_to"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.training_level"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.typical_settings"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.whenYouSeeThem",
    "sourceText": "When you need support from a pharmacy assistant; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.worksWith.0",
    "sourceText": "Pharmacist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.works_with"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.worksWith.1",
    "sourceText": "Pharmacy Technician",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.works_with"
    ]
  },
  {
    "id": "roles:items.pharmacy_assistant.worksWith.2",
    "sourceText": "Ward Clerk",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.pharmacy_assistant.works_with"
    ]
  },
  {
    "id": "roles:items.physician.description",
    "sourceText": "A physician is a doctor who specialises in diagnosing and treating medical conditions, usually without surgery. Physicians may focus on areas such as heart, lung, kidney, digestive or older-person care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.description"
    ]
  },
  {
    "id": "roles:items.physician.experienceNeeded",
    "sourceText": "Medical degree followed by postgraduate medical and specialty training appropriate to their field.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.experience_needed"
    ]
  },
  {
    "id": "roles:items.physician.faqs.0.answer",
    "sourceText": "A physician is a doctor. In UK healthcare, the word usually describes a doctor specialising in medical rather than surgical care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.faqs"
    ]
  },
  {
    "id": "roles:items.physician.faqs.0.question",
    "sourceText": "Is a physician the same as a doctor?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.faqs"
    ]
  },
  {
    "id": "roles:items.physician.faqs.1.answer",
    "sourceText": "Some do. The procedures depend on their specialty, training and the clinical setting.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.faqs"
    ]
  },
  {
    "id": "roles:items.physician.faqs.1.question",
    "sourceText": "Do physicians perform procedures?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.faqs"
    ]
  },
  {
    "id": "roles:items.physician.faqs.2.answer",
    "sourceText": "You may see a physician with broad expertise or one specialising in a particular organ system or condition.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.faqs"
    ]
  },
  {
    "id": "roles:items.physician.faqs.2.question",
    "sourceText": "Will I see a general physician or a specialist?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.faqs"
    ]
  },
  {
    "id": "roles:items.physician.keyResponsibilities.0",
    "sourceText": "Assess complex medical symptoms",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.physician.keyResponsibilities.1",
    "sourceText": "Diagnose and manage acute or long-term illness",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.physician.keyResponsibilities.2",
    "sourceText": "Request and interpret tests",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.physician.keyResponsibilities.3",
    "sourceText": "Recommend medicines and other treatments",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.physician.keyResponsibilities.4",
    "sourceText": "Coordinate care when several conditions are involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.physician.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.locations"
    ]
  },
  {
    "id": "roles:items.physician.locations.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.locations"
    ]
  },
  {
    "id": "roles:items.physician.notQualifiedTo.0",
    "sourceText": "Work beyond their competence or agreed scope of practice",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.physician.notQualifiedTo.1",
    "sourceText": "Replace another specialist when different expertise is required",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.physician.reportsTo",
    "sourceText": "Consultant or clinical lead, depending on grade and role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.reports_to"
    ]
  },
  {
    "id": "roles:items.physician.trainingLevel",
    "sourceText": "Medical degree followed by postgraduate medical and specialty training appropriate to their field.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.training_level"
    ]
  },
  {
    "id": "roles:items.physician.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.typical_settings"
    ]
  },
  {
    "id": "roles:items.physician.typicalSettings.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.typical_settings"
    ]
  },
  {
    "id": "roles:items.physician.whenYouSeeThem",
    "sourceText": "On a medical ward, In a specialist outpatient clinic, After referral from a GP or another doctor",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.physician.worksWith.0",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.works_with"
    ]
  },
  {
    "id": "roles:items.physician.worksWith.1",
    "sourceText": "Specialty Registrar Str",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.works_with"
    ]
  },
  {
    "id": "roles:items.physician.worksWith.2",
    "sourceText": "Surgeon",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.works_with"
    ]
  },
  {
    "id": "roles:items.physician.worksWith.3",
    "sourceText": "General Practitioner Gp",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.physician.works_with"
    ]
  },
  {
    "id": "roles:items.practice_nurse.description",
    "sourceText": "A registered nurse who provides nursing care and health checks in a GP practice.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.practice_nurse.description"
    ]
  },
  {
    "id": "roles:items.practice_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.practice_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.practice_nurse.locations.0",
    "sourceText": "GP Practices",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.practice_nurse.locations.0"
    ]
  },
  {
    "id": "roles:items.practice_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.practice_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.practice_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.practice_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.practice_nurse.typicalSettings.0",
    "sourceText": "GP Practices",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.practice_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.practice_nurse.typicalSettings.1",
    "sourceText": "Community Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.practice_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.practice_nurse.whenYouSeeThem",
    "sourceText": "A registered nurse who provides nursing care and health checks in a GP practice.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.practice_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.prosthetist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.experience_needed"
    ]
  },
  {
    "id": "roles:items.prosthetist.faqs.0.answer",
    "sourceText": "Timing varies. Healing, strength, health and your goals all affect when fitting can begin.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.faqs"
    ]
  },
  {
    "id": "roles:items.prosthetist.faqs.0.question",
    "sourceText": "Will I receive a prosthesis immediately?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.faqs"
    ]
  },
  {
    "id": "roles:items.prosthetist.faqs.1.answer",
    "sourceText": "Tell the prosthetist promptly. Fit and comfort often need adjustment, especially early on.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.faqs"
    ]
  },
  {
    "id": "roles:items.prosthetist.faqs.1.question",
    "sourceText": "What if the prosthesis is uncomfortable?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.faqs"
    ]
  },
  {
    "id": "roles:items.prosthetist.faqs.2.answer",
    "sourceText": "Often, yes. Physiotherapists and prosthetists commonly work together to help you use the limb safely.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.faqs"
    ]
  },
  {
    "id": "roles:items.prosthetist.faqs.2.question",
    "sourceText": "Will I need physiotherapy too?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.faqs"
    ]
  },
  {
    "id": "roles:items.prosthetist.keyResponsibilities.0",
    "sourceText": "Take measurements and assess movement",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.prosthetist.keyResponsibilities.1",
    "sourceText": "Work with technicians to produce or adapt a prosthesis",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.prosthetist.keyResponsibilities.2",
    "sourceText": "Check fit, alignment and comfort",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.prosthetist.keyResponsibilities.3",
    "sourceText": "Support practice alongside physiotherapy",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.prosthetist.keyResponsibilities.4",
    "sourceText": "Arrange maintenance and follow-up",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.prosthetist.locations.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.locations"
    ]
  },
  {
    "id": "roles:items.prosthetist.locations.1",
    "sourceText": "Rehabilitation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.locations"
    ]
  },
  {
    "id": "roles:items.prosthetist.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.locations"
    ]
  },
  {
    "id": "roles:items.prosthetist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.reports_to"
    ]
  },
  {
    "id": "roles:items.prosthetist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.training_level"
    ]
  },
  {
    "id": "roles:items.prosthetist.typicalSettings.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.typical_settings"
    ]
  },
  {
    "id": "roles:items.prosthetist.typicalSettings.1",
    "sourceText": "Rehabilitation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.typical_settings"
    ]
  },
  {
    "id": "roles:items.prosthetist.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.typical_settings"
    ]
  },
  {
    "id": "roles:items.prosthetist.whenYouSeeThem",
    "sourceText": "After an amputation; During rehabilitation; When an existing prosthesis needs adjustment or replacement",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.prosthetist.worksWith.0",
    "sourceText": "Orthotist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.works_with"
    ]
  },
  {
    "id": "roles:items.prosthetist.worksWith.1",
    "sourceText": "Physiotherapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.works_with"
    ]
  },
  {
    "id": "roles:items.prosthetist.worksWith.2",
    "sourceText": "Occupational Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.works_with"
    ]
  },
  {
    "id": "roles:items.prosthetist.worksWith.3",
    "sourceText": "Surgeon",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.works_with"
    ]
  },
  {
    "id": "roles:items.prosthetist.worksWith.4",
    "sourceText": "Rehabilitation Assistant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.prosthetist.works_with"
    ]
  },
  {
    "id": "roles:items.psychiatrist.description",
    "sourceText": "A medical doctor who assesses and treats mental health conditions, including with medicines when appropriate.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.description"
    ]
  },
  {
    "id": "roles:items.psychiatrist.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.experience_needed"
    ]
  },
  {
    "id": "roles:items.psychiatrist.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the psychiatrist role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.psychiatrist.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.psychiatrist.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.psychiatrist.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.psychiatrist.locations.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.locations"
    ]
  },
  {
    "id": "roles:items.psychiatrist.locations.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.locations"
    ]
  },
  {
    "id": "roles:items.psychiatrist.locations.2",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.locations"
    ]
  },
  {
    "id": "roles:items.psychiatrist.locations.3",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.locations"
    ]
  },
  {
    "id": "roles:items.psychiatrist.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.reports_to"
    ]
  },
  {
    "id": "roles:items.psychiatrist.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.training_level"
    ]
  },
  {
    "id": "roles:items.psychiatrist.typicalSettings.0",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.typical_settings"
    ]
  },
  {
    "id": "roles:items.psychiatrist.typicalSettings.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.typical_settings"
    ]
  },
  {
    "id": "roles:items.psychiatrist.typicalSettings.2",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.typical_settings"
    ]
  },
  {
    "id": "roles:items.psychiatrist.typicalSettings.3",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.typical_settings"
    ]
  },
  {
    "id": "roles:items.psychiatrist.whenYouSeeThem",
    "sourceText": "When you need support from a psychiatrist; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.psychiatrist.worksWith.0",
    "sourceText": "Clinical Psychologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.works_with"
    ]
  },
  {
    "id": "roles:items.psychiatrist.worksWith.1",
    "sourceText": "Mental Health Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.works_with"
    ]
  },
  {
    "id": "roles:items.psychiatrist.worksWith.2",
    "sourceText": "General Practitioner Gp",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.works_with"
    ]
  },
  {
    "id": "roles:items.psychiatrist.worksWith.3",
    "sourceText": "Social Worker",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.psychiatrist.works_with"
    ]
  },
  {
    "id": "roles:items.radiologist.description",
    "sourceText": "A radiologist is a doctor who interprets medical images such as X-rays, CT scans, MRI scans and ultrasound. Some radiologists also perform image-guided procedures and treatments.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.description"
    ]
  },
  {
    "id": "roles:items.radiologist.experienceNeeded",
    "sourceText": "Medical degree followed by specialist postgraduate training in clinical radiology, with additional training for subspecialty or interventional practice.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.experience_needed"
    ]
  },
  {
    "id": "roles:items.radiologist.faqs.0.answer",
    "sourceText": "Usually no. A radiographer or sonographer commonly performs the scan, while a radiologist interprets it. Roles vary for some ultrasound and specialist procedures.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.faqs"
    ]
  },
  {
    "id": "roles:items.radiologist.faqs.0.question",
    "sourceText": "Is a radiologist the person who takes my scan?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.faqs"
    ]
  },
  {
    "id": "roles:items.radiologist.faqs.1.answer",
    "sourceText": "Much of a radiologist’s work happens behind the scenes. Their report is sent to the clinician responsible for explaining the result in the context of your care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.faqs"
    ]
  },
  {
    "id": "roles:items.radiologist.faqs.1.question",
    "sourceText": "Why have I not met the radiologist who reported my scan?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.faqs"
    ]
  },
  {
    "id": "roles:items.radiologist.faqs.2.answer",
    "sourceText": "Interventional radiologists perform minimally invasive procedures using imaging guidance, but these differ from conventional surgery.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.faqs"
    ]
  },
  {
    "id": "roles:items.radiologist.faqs.2.question",
    "sourceText": "Do radiologists perform operations?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.faqs"
    ]
  },
  {
    "id": "roles:items.radiologist.keyResponsibilities.0",
    "sourceText": "Interpret X-rays and scans",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.radiologist.keyResponsibilities.1",
    "sourceText": "Advise other clinicians on the best imaging test",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.radiologist.keyResponsibilities.2",
    "sourceText": "Write reports that help guide diagnosis and treatment",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.radiologist.keyResponsibilities.3",
    "sourceText": "Discuss complex imaging findings with clinical teams",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.radiologist.keyResponsibilities.4",
    "sourceText": "Perform image-guided procedures in interventional radiology",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.radiologist.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.locations"
    ]
  },
  {
    "id": "roles:items.radiologist.locations.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.locations"
    ]
  },
  {
    "id": "roles:items.radiologist.notQualifiedTo.0",
    "sourceText": "Work beyond their competence or agreed scope of practice",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.radiologist.notQualifiedTo.1",
    "sourceText": "Replace another specialist when different expertise is required",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.radiologist.reportsTo",
    "sourceText": "Clinical director or radiology clinical lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.reports_to"
    ]
  },
  {
    "id": "roles:items.radiologist.trainingLevel",
    "sourceText": "Medical degree followed by specialist postgraduate training in clinical radiology, with additional training for subspecialty or interventional practice.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.training_level"
    ]
  },
  {
    "id": "roles:items.radiologist.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.radiologist.typicalSettings.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.radiologist.whenYouSeeThem",
    "sourceText": "You may not meet them directly when they report a scan, Before or during an image-guided procedure, In a specialist radiology clinic",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.radiologist.worksWith.0",
    "sourceText": "Radiographer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.works_with"
    ]
  },
  {
    "id": "roles:items.radiologist.worksWith.1",
    "sourceText": "Sonographer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.works_with"
    ]
  },
  {
    "id": "roles:items.radiologist.worksWith.2",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.works_with"
    ]
  },
  {
    "id": "roles:items.radiologist.worksWith.3",
    "sourceText": "Surgeon",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.radiologist.works_with"
    ]
  },
  {
    "id": "roles:items.research_nurse.description",
    "sourceText": "A registered nurse who supports people taking part in health and care research.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.research_nurse.description"
    ]
  },
  {
    "id": "roles:items.research_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.research_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.research_nurse.locations.1",
    "sourceText": "Research Units",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.research_nurse.locations.1"
    ]
  },
  {
    "id": "roles:items.research_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.research_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.research_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.research_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.research_nurse.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.research_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.research_nurse.typicalSettings.1",
    "sourceText": "Research Units",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.research_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.research_nurse.typicalSettings.2",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.research_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.research_nurse.whenYouSeeThem",
    "sourceText": "A registered nurse who supports people taking part in health and care research.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.research_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.experience_needed"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.locations.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.locations.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.locations.2",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.locations.3",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.reports_to"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.training_level"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.typicalSettings.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.typicalSettings.1",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.typicalSettings.2",
    "sourceText": "Critical Care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.respiratory_physiologist.typicalSettings.3",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.respiratory_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.school_nurse.description",
    "sourceText": "A specialist community nurse who supports the health and wellbeing of school-aged children and young people.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.school_nurse.description"
    ]
  },
  {
    "id": "roles:items.school_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.school_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.school_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.school_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.school_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.school_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.school_nurse.typicalSettings.0",
    "sourceText": "Schools",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.school_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.school_nurse.typicalSettings.1",
    "sourceText": "Community Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.school_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.school_nurse.whenYouSeeThem",
    "sourceText": "A specialist community nurse who supports the health and wellbeing of school-aged children and young people.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.school_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.security_officer.description",
    "sourceText": "Helps keep patients, visitors and staff safe across hospital sites.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.description"
    ]
  },
  {
    "id": "roles:items.security_officer.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.experience_needed"
    ]
  },
  {
    "id": "roles:items.security_officer.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the security officer role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.security_officer.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.security_officer.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.security_officer.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.security_officer.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.locations"
    ]
  },
  {
    "id": "roles:items.security_officer.locations.1",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.locations"
    ]
  },
  {
    "id": "roles:items.security_officer.locations.2",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.locations"
    ]
  },
  {
    "id": "roles:items.security_officer.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.reports_to"
    ]
  },
  {
    "id": "roles:items.security_officer.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.training_level"
    ]
  },
  {
    "id": "roles:items.security_officer.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.typical_settings"
    ]
  },
  {
    "id": "roles:items.security_officer.typicalSettings.1",
    "sourceText": "Emergency Department",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.typical_settings"
    ]
  },
  {
    "id": "roles:items.security_officer.typicalSettings.2",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.typical_settings"
    ]
  },
  {
    "id": "roles:items.security_officer.whenYouSeeThem",
    "sourceText": "When you need support from a security officer; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.security_officer.worksWith.0",
    "sourceText": "Receptionist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.works_with"
    ]
  },
  {
    "id": "roles:items.security_officer.worksWith.1",
    "sourceText": "Staff Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.works_with"
    ]
  },
  {
    "id": "roles:items.security_officer.worksWith.2",
    "sourceText": "Patient Experience Officer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.security_officer.works_with"
    ]
  },
  {
    "id": "roles:items.sleep_physiologist.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sleep_physiologist.experience_needed"
    ]
  },
  {
    "id": "roles:items.sleep_physiologist.locations.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sleep_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.sleep_physiologist.locations.1",
    "sourceText": "Home Visits",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sleep_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.sleep_physiologist.locations.2",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sleep_physiologist.locations"
    ]
  },
  {
    "id": "roles:items.sleep_physiologist.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sleep_physiologist.reports_to"
    ]
  },
  {
    "id": "roles:items.sleep_physiologist.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sleep_physiologist.training_level"
    ]
  },
  {
    "id": "roles:items.sleep_physiologist.typicalSettings.0",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sleep_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.sleep_physiologist.typicalSettings.1",
    "sourceText": "Home Visits",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sleep_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.sleep_physiologist.typicalSettings.2",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sleep_physiologist.typical_settings"
    ]
  },
  {
    "id": "roles:items.social_worker.description",
    "sourceText": "Helps with practical, social and safeguarding needs that may affect your health, independence or discharge.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.description"
    ]
  },
  {
    "id": "roles:items.social_worker.experienceNeeded",
    "sourceText": "Role-specific training and experience",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.experience_needed"
    ]
  },
  {
    "id": "roles:items.social_worker.keyResponsibilities.0",
    "sourceText": "Provide the specialist support associated with the social worker role",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.social_worker.keyResponsibilities.1",
    "sourceText": "Share relevant information with you and the wider care team",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.social_worker.keyResponsibilities.2",
    "sourceText": "Document and communicate their contribution to your care",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.social_worker.keyResponsibilities.3",
    "sourceText": "Follow professional standards and local policies",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.social_worker.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.locations"
    ]
  },
  {
    "id": "roles:items.social_worker.locations.1",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.locations"
    ]
  },
  {
    "id": "roles:items.social_worker.locations.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.locations"
    ]
  },
  {
    "id": "roles:items.social_worker.locations.3",
    "sourceText": "Home Visits",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.locations"
    ]
  },
  {
    "id": "roles:items.social_worker.reportsTo",
    "sourceText": "Service or department lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.reports_to"
    ]
  },
  {
    "id": "roles:items.social_worker.trainingLevel",
    "sourceText": "Training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.training_level"
    ]
  },
  {
    "id": "roles:items.social_worker.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.typical_settings"
    ]
  },
  {
    "id": "roles:items.social_worker.typicalSettings.1",
    "sourceText": "Mental Health Services",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.typical_settings"
    ]
  },
  {
    "id": "roles:items.social_worker.typicalSettings.2",
    "sourceText": "Community",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.typical_settings"
    ]
  },
  {
    "id": "roles:items.social_worker.typicalSettings.3",
    "sourceText": "Home Visits",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.typical_settings"
    ]
  },
  {
    "id": "roles:items.social_worker.whenYouSeeThem",
    "sourceText": "When you need support from a social worker; During an appointment, admission or follow-up relevant to their service; When another member of the team asks them to become involved",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.social_worker.worksWith.0",
    "sourceText": "Discharge Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.works_with"
    ]
  },
  {
    "id": "roles:items.social_worker.worksWith.1",
    "sourceText": "Care Coordinator",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.works_with"
    ]
  },
  {
    "id": "roles:items.social_worker.worksWith.2",
    "sourceText": "Mental Health Nurse",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.works_with"
    ]
  },
  {
    "id": "roles:items.social_worker.worksWith.3",
    "sourceText": "Occupational Therapist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.social_worker.works_with"
    ]
  },
  {
    "id": "roles:items.sonographer.experienceNeeded",
    "sourceText": "Varies by post and level of responsibility",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.experience_needed"
    ]
  },
  {
    "id": "roles:items.sonographer.faqs.0.answer",
    "sourceText": "No. Ultrasound uses high-frequency sound waves.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.faqs"
    ]
  },
  {
    "id": "roles:items.sonographer.faqs.0.question",
    "sourceText": "Does an ultrasound use radiation?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.faqs"
    ]
  },
  {
    "id": "roles:items.sonographer.faqs.1.answer",
    "sourceText": "This varies by scan and service. They will explain how and when you should receive the result.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.faqs"
    ]
  },
  {
    "id": "roles:items.sonographer.faqs.1.question",
    "sourceText": "Will the sonographer tell me the result immediately?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.faqs"
    ]
  },
  {
    "id": "roles:items.sonographer.faqs.2.answer",
    "sourceText": "Most scans are not painful, although pressure may feel uncomfortable over a tender area.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.faqs"
    ]
  },
  {
    "id": "roles:items.sonographer.faqs.2.question",
    "sourceText": "Will the scan hurt?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.faqs"
    ]
  },
  {
    "id": "roles:items.sonographer.keyResponsibilities.0",
    "sourceText": "Confirm the scan and relevant history",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.sonographer.keyResponsibilities.1",
    "sourceText": "Explain what will happen",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.sonographer.keyResponsibilities.2",
    "sourceText": "Use an ultrasound probe to obtain images",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.sonographer.keyResponsibilities.3",
    "sourceText": "Record measurements and observations",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.sonographer.keyResponsibilities.4",
    "sourceText": "Prepare a report or work with a doctor who interprets the scan",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.sonographer.locations.0",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.locations"
    ]
  },
  {
    "id": "roles:items.sonographer.locations.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.locations"
    ]
  },
  {
    "id": "roles:items.sonographer.locations.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.locations"
    ]
  },
  {
    "id": "roles:items.sonographer.locations.3",
    "sourceText": "Maternity",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.locations"
    ]
  },
  {
    "id": "roles:items.sonographer.reportsTo",
    "sourceText": "Local clinical or professional lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.reports_to"
    ]
  },
  {
    "id": "roles:items.sonographer.trainingLevel",
    "sourceText": "Professional training and registration requirements depend on the role.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.training_level"
    ]
  },
  {
    "id": "roles:items.sonographer.typicalSettings.0",
    "sourceText": "Diagnostics Imaging",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.typical_settings"
    ]
  },
  {
    "id": "roles:items.sonographer.typicalSettings.1",
    "sourceText": "Outpatients Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.typical_settings"
    ]
  },
  {
    "id": "roles:items.sonographer.typicalSettings.2",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.typical_settings"
    ]
  },
  {
    "id": "roles:items.sonographer.typicalSettings.3",
    "sourceText": "Maternity",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.typical_settings"
    ]
  },
  {
    "id": "roles:items.sonographer.whenYouSeeThem",
    "sourceText": "During pregnancy; For scans of the abdomen, pelvis, heart or blood vessels; When investigating pain, swelling or other symptoms",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.sonographer.worksWith.0",
    "sourceText": "Radiographer",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.works_with"
    ]
  },
  {
    "id": "roles:items.sonographer.worksWith.1",
    "sourceText": "Radiologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.works_with"
    ]
  },
  {
    "id": "roles:items.sonographer.worksWith.2",
    "sourceText": "Obstetrician",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.works_with"
    ]
  },
  {
    "id": "roles:items.sonographer.worksWith.3",
    "sourceText": "Midwife",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.works_with"
    ]
  },
  {
    "id": "roles:items.sonographer.worksWith.4",
    "sourceText": "Cardiac Physiologist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.sonographer.works_with"
    ]
  },
  {
    "id": "roles:items.specialist_nurse.description",
    "sourceText": "An experienced nurse with additional knowledge in a particular condition, treatment or area of care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialist_nurse.description"
    ]
  },
  {
    "id": "roles:items.specialist_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialist_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.specialist_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialist_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.specialist_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialist_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.specialist_nurse.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialist_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.specialist_nurse.typicalSettings.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialist_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.specialist_nurse.typicalSettings.2",
    "sourceText": "Community Settings",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialist_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.specialist_nurse.whenYouSeeThem",
    "sourceText": "An experienced nurse with additional knowledge in a particular condition, treatment or area of care.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialist_nurse.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.description",
    "sourceText": "A specialty doctor is an experienced hospital doctor who works in a particular field but is not in a formal training post. Many provide senior, independent care within an agreed scope and are key permanent members of clinical teams.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.description"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.experienceNeeded",
    "sourceText": "Medical degree, full professional registration and substantial postgraduate experience in the relevant specialty.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.experience_needed"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.faqs.0.answer",
    "sourceText": "Usually no. Specialty doctor is a career-grade role rather than a formal training post, although doctors continue professional development throughout their careers.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.faqs.0.question",
    "sourceText": "Are specialty doctors still in training?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.faqs.1.answer",
    "sourceText": "The term can be misleading. Many specialty doctors are highly experienced and may work independently within an agreed area of practice.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.faqs.1.question",
    "sourceText": "Are they junior doctors?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.faqs.2.answer",
    "sourceText": "No. The roles and contractual requirements differ, but an experienced specialty doctor may lead significant parts of care and have substantial specialist expertise.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.faqs.2.question",
    "sourceText": "Are they the same as consultants?",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.faqs"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.keyResponsibilities.0",
    "sourceText": "Assess and treat patients in their specialty",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.keyResponsibilities.1",
    "sourceText": "Run clinics, ward reviews or procedure lists within their competence",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.keyResponsibilities.2",
    "sourceText": "Make day-to-day clinical decisions",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.keyResponsibilities.3",
    "sourceText": "Support and supervise other team members",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.keyResponsibilities.4",
    "sourceText": "Seek or provide senior advice according to local arrangements",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.key_responsibilities"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.locations.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.locations"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.locations.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.locations"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.notQualifiedTo.0",
    "sourceText": "Work beyond their competence or agreed scope of practice",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.notQualifiedTo.1",
    "sourceText": "Replace another specialist when different expertise is required",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.not_qualified_to"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.reportsTo",
    "sourceText": "Clinical lead or consultant, depending on scope and local arrangements",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.reports_to"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.trainingLevel",
    "sourceText": "Medical degree, full professional registration and substantial postgraduate experience in the relevant specialty.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.training_level"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.typicalSettings.0",
    "sourceText": "Hospital Wards",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.typical_settings"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.typicalSettings.1",
    "sourceText": "Outpatient Clinics",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.typical_settings"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.whenYouSeeThem",
    "sourceText": "On a hospital ward, In an outpatient clinic, During a procedure or operation",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.when_you_see_them"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.worksWith.0",
    "sourceText": "Consultant",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.works_with"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.worksWith.1",
    "sourceText": "Associate Specialist",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.works_with"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.worksWith.2",
    "sourceText": "Resident Doctor Previously Referred To As Junior Doctor",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.works_with"
    ]
  },
  {
    "id": "roles:items.specialty_doctor.worksWith.3",
    "sourceText": "Specialty Registrar Str",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.specialty_doctor.works_with"
    ]
  },
  {
    "id": "roles:items.theatre_nurse.description",
    "sourceText": "A registered nurse who helps provide safe care before, during and after an operation.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.theatre_nurse.description"
    ]
  },
  {
    "id": "roles:items.theatre_nurse.experienceNeeded",
    "sourceText": "Role-specific experience and training",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.theatre_nurse.experience_needed"
    ]
  },
  {
    "id": "roles:items.theatre_nurse.locations.1",
    "sourceText": "Day Surgery Units",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.theatre_nurse.locations.1"
    ]
  },
  {
    "id": "roles:items.theatre_nurse.reportsTo",
    "sourceText": "Registered clinical or service lead",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.theatre_nurse.reports_to"
    ]
  },
  {
    "id": "roles:items.theatre_nurse.trainingLevel",
    "sourceText": "Varies according to role and professional requirements.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.theatre_nurse.training_level"
    ]
  },
  {
    "id": "roles:items.theatre_nurse.typicalSettings.0",
    "sourceText": "Operating Theatres",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.theatre_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.theatre_nurse.typicalSettings.1",
    "sourceText": "Day Surgery Units",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.theatre_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.theatre_nurse.typicalSettings.2",
    "sourceText": "Recovery Areas",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.theatre_nurse.typical_settings"
    ]
  },
  {
    "id": "roles:items.theatre_nurse.whenYouSeeThem",
    "sourceText": "A registered nurse who helps provide safe care before, during and after an operation.",
    "contentArea": "know_your_team",
    "contexts": [
      "directClinical:jobRole.theatre_nurse.when_you_see_them"
    ]
  }
];
